var la = Object.defineProperty, da = Object.defineProperties;
var ua = Object.getOwnPropertyDescriptors;
var ze = Object.getOwnPropertySymbols;
var Rt = Object.prototype.hasOwnProperty, Mt = Object.prototype.propertyIsEnumerable;
var Bt = (e) => {
  throw TypeError(e);
};
var it = (e, n, t) => n in e ? la(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, N = (e, n) => {
  for (var t in n || (n = {}))
    Rt.call(n, t) && it(e, t, n[t]);
  if (ze)
    for (var t of ze(n))
      Mt.call(n, t) && it(e, t, n[t]);
  return e;
}, D = (e, n) => da(e, ua(n));
var j = (e, n) => {
  var t = {};
  for (var a in e)
    Rt.call(e, a) && n.indexOf(a) < 0 && (t[a] = e[a]);
  if (e != null && ze)
    for (var a of ze(e))
      n.indexOf(a) < 0 && Mt.call(e, a) && (t[a] = e[a]);
  return t;
};
var st = (e, n, t) => it(e, typeof n != "symbol" ? n + "" : n, t), xt = (e, n, t) => n.has(e) || Bt("Cannot " + t);
var Pe = (e, n, t) => (xt(e, n, "read from private field"), t ? t.call(e) : n.get(e)), ot = (e, n, t) => n.has(e) ? Bt("Cannot add the same private member more than once") : n instanceof WeakSet ? n.add(e) : n.set(e, t), rt = (e, n, t, a) => (xt(e, n, "write to private field"), a ? a.call(e, t) : n.set(e, t), t);
var K = (e, n, t) => new Promise((a, i) => {
  var o = (d) => {
    try {
      c(t.next(d));
    } catch (l) {
      i(l);
    }
  }, r = (d) => {
    try {
      c(t.throw(d));
    } catch (l) {
      i(l);
    }
  }, c = (d) => d.done ? a(d.value) : Promise.resolve(d.value).then(o, r);
  c((t = t.apply(e, n)).next());
});
import { jsx as s, jsxs as S, Fragment as H } from "react/jsx-runtime";
import { M as ga, u as U, P as ut, a as Qt, b as ht, c as Ht, d as gt, e as E, f as Xt, g as Yt, h as pa, T as q, S as pe, i as he, j as Ze, k as Sa, r as ma, l as Te, $ as ha, m as bt, n as Zt, o as qe, p as Jt, q as Oe, s as Z, t as ba, v as en, B as re, w as be, x as tn, y as fa, z as Ae, A as ft, C as Qe, D as Ca, E as ce, F as Ct, G as nn, H as me, I as an, J as fe, K as _a, L as De, N as va, O as ka, Q as La, R as Na, U as Ia, V as Ta, W as ae, X as Aa, Y as sn, Z as on, _ as rn, a0 as Ee, a1 as Re, a2 as He, a3 as _t, a4 as vt, a5 as cn, a6 as ln, a7 as Ea, a8 as ya, a9 as Vt, aa as kt, ab as dn, ac as Lt, ad as un, ae as Pa, af as gn, ag as pn, ah as Sn, ai as wa, aj as Ga, ak as mn, al as Oa, am as Ut, an as hn, ao as Da, ap as Ra, aq as Ma, ar as Ba, as as Ke, at as xa, au as Va, av as Ua, aw as Fa, ax as bn, ay as Nt, az as It, aA as Ft, aB as $a, aC as fn, aD as za, aE as Cn, aF as Wa, aG as Ka, aH as ja, aI as qa, aJ as _n, aK as Je, aL as Qa, aM as Ha, aN as $t, aO as vn, aP as Xa, aQ as Ya, aR as Tt, aS as Za, aT as Ja, aU as ei, aV as kn, aW as ti, aX as ni, aY as ai, aZ as ii, a_ as si, a$ as oi, b0 as ri, b1 as ci, b2 as li, b3 as di, b4 as ui, b5 as gi, b6 as pi, b7 as Si, b8 as mi, b9 as hi, ba as bi, bb as fi, bc as Ci, bd as _i, be as vi, bf as ki, bg as Li, bh as Ni, bi as Ii, bj as Ti, bk as Ai, bl as Ei, bm as yi, bn as Pi, bo as wi, bp as Gi, bq as Oi, br as Di, bs as Ri, bt as Mi, bu as Bi, bv as le, bw as ie, bx as xi } from "./App-ChpItgs-.js";
import { bz as Qr, bA as Hr, bC as Xr, by as Yr, bB as Zr } from "./App-ChpItgs-.js";
import { useEffect as B, createContext as Ce, useContext as _e, useState as $, useCallback as O, useMemo as Me, memo as de, PureComponent as Be, useReducer as Vi, useRef as Ui } from "react";
import { getShortId as Q, ColoredItemAdminModal as Fi, useTicketingSdkContext as $i, getEntityId as G, TicketingSdkContext as At, ContingentSelector as Ln, StockNotInContingent as zi, EditableStockContingentRow as pt, getErrorDescription as xe, usePrevious as we, FormattedDateForStartAndEndDate as Wi, getCustomerFullname as Ve, getFormattedPhoneNumberObject as Ki, formatPrice as oe, useDomainContext as Ue, getFormattedTicketPriceFacialValue as ji, DOMAIN_CONTEXT as ge } from "@mapado/js-component";
import { assertRelationIsDefined as M, assertRelationIsString as Y, AVAILABLE_SEAT_STATUS_DISMISSED as et, StockContingent as Xe, assertRelationIsObject as f, assertRelationIsListOfString as Nn, AVAILABLE_SEAT_BOOKING_STATUS as ne, Cart as qi, CART_TYPE as St, assertRelationIsListOfObject as z, assertRelationIsNullOrObject as F, Contingent as Qi, AVAILABLE_SEAT_STATUS_AVAILABLE as Ge, PagedCollection as mt, Booking as zt, BOOKING_ENTITY_NAME as Le, assertRelationIsNullOrString as Hi, AVAILABLE_SEAT_STATUS_BOOKED as Xi, AVAILABLE_SEAT_STATUS_PAID as Yi } from "@mapado/ticketing-js-sdk";
import { MpdLoader as tt, MpdIcon as Se, MpdPopover as Zi, useMpdToast as te, TOAST_TYPE as ve, MpdModal as In, MpdSingleSelect as Ji, hexToRGB as Tn } from "@mapado/makeup";
import { createPortal as Et } from "react-dom";
import nt from "classnames";
import { List as A, Set as V, Map as W } from "immutable";
import { connect as se } from "react-redux";
import An from "moment";
import { useCurrentCartBookingError as es, useCurrentCartMapadoError as ts, useCurrentCart as ns, useLockSeatsForEventDate as as, useSetTicketPriceQuantity as is, useChangeAvailableSeatTicketPrice as ss, NO_STOCK_CONTINGENT as os, SHOPPING_CART as ct, getCartItemQuantityForAvailableSeat as rs } from "@mapado/cart";
function cs({
  planList: e,
  hiddenPlanContext: n,
  selectedIndex: t,
  onSelectIndex: a
}) {
  const i = !!t, o = {};
  e.forEach(({ name: c, render: d }) => {
    o[c] = d;
  });
  const r = Object.keys(o);
  return B(() => {
    !i && r.length > 0 && a(r[0]);
  }, [r, i, a]), !t || !o[t] ? null : /* @__PURE__ */ s(
    ga.Provider,
    {
      value: {
        elementList: o,
        hiddenPlanContext: n,
        selectedIndex: t,
        onSelect: a
      },
      children: o[t]()
    }
  );
}
const En = Ce(null);
function ye() {
  const e = _e(En);
  if (e === null)
    throw new Error(
      "`useSelectedSeatGroupContext` must be used within a `SelectedSeatGroupContextProvider`"
    );
  return e;
}
function yn({
  children: e
}) {
  const n = U(), [t, a] = $(null), i = O(
    (c) => {
      t && c["@id"] === t["@id"] ? (a(null), n({ type: ut })) : (a(c), n({ type: Qt, seatGroup: c }));
    },
    [n, t]
  ), o = O(() => {
    a(null), n({ type: ut });
  }, [n]), r = Me(
    () => ({ selectedSeatGroup: t, handleSelectSeatGroup: i, unselectSeatGroup: o }),
    [i, t, o]
  );
  return /* @__PURE__ */ s(En.Provider, { value: r, children: e });
}
var P = /* @__PURE__ */ ((e) => (e.CONTINGENT = "CONTINGENT", e.SEAT_GROUP = "SEAT_GROUP", e.GAUGE = "GAUGE", e))(P || {});
const Pn = [
  "totalStock",
  "bookableStock",
  "bookedTickets",
  "availableSeatList",
  "seatList",
  "draft",
  { contingent: ["@id", "name", "color"] }
], wn = Ce(null), ke = () => {
  const e = _e(wn);
  if (e === null)
    throw new Error(
      "useStockManagementContext must be used within a StockManagementProvider"
    );
  return e;
};
function ls({
  children: e,
  initialTab: n = "CONTINGENT"
  /* CONTINGENT */
}) {
  const t = ht(), a = U(), [i, o] = $(n), [r, c] = $(null), { unselectSeatGroup: d } = ye(), l = O(
    (h) => {
      c(h), a({
        type: Ht,
        stockContingent: h
      });
    },
    [a]
  ), u = O(() => {
    c(null), a({ type: gt });
  }, [a]), p = O(
    (h) => {
      o(h), c(null), d(), a({ type: gt });
    },
    [a, d]
  );
  if (!t || !t["@id"])
    throw new Error("EventDate should exist");
  const g = Number(Q(t["@id"]));
  M(
    t.ticketing.wallet,
    "eventDate.ticketing.wallet"
  ), Y(
    t.ticketing.wallet.contract,
    "eventDate.ticketing.wallet.contract"
  );
  const m = t.ticketing.wallet.contract, _ = Me(
    () => ({
      // TODO this eventDate is only a passed selector from redux
      eventDateId: g,
      contractId: m,
      selectedTab: i,
      selectTab: p,
      selectedStockContingent: r,
      selectStockContingent: l,
      unselectStockContingent: u
    }),
    [
      m,
      g,
      p,
      r,
      i,
      l,
      u
    ]
  );
  return /* @__PURE__ */ s(wn.Provider, { value: _, children: e });
}
function ue() {
  return /* @__PURE__ */ s("div", { className: "mpd-seating__app context-reservation", id: "mpd-seating__app", children: /* @__PURE__ */ s("div", { className: "mpd-seating__app--is-loading", children: /* @__PURE__ */ s(tt, {}) }) });
}
function ds({
  seatGroup: e,
  onClick: n,
  tabIndex: t
}) {
  var a;
  return /* @__PURE__ */ S(
    "div",
    {
      className: "contingent-selector__row",
      onClick: n,
      onKeyDown: n,
      tabIndex: t,
      role: "button",
      children: [
        /* @__PURE__ */ s(
          Se,
          {
            icon: "seat-filled",
            color: (a = e.seatColor) != null ? a : void 0,
            width: "12",
            className: "mr2"
          }
        ),
        e.label
      ]
    }
  );
}
function us(e) {
  const n = $i(), [t, a] = $(
    null
  ), i = O(() => {
    n.getRepository("seatGroup").findBy(
      {
        contract: e,
        "order[label]": "ASC",
        itemsPerPage: 9999
      },
      ["@id", "seatColor", "label", "seatConfigId"]
    ).then((o) => a(o.getMembers()));
  }, [n, e]);
  return { seatGroupList: t, fetchSeatGroupList: i };
}
function gs({
  contractId: e,
  onChange: n,
  onSubmitAdminModal: t,
  label: a,
  labelClassName: i = "ml2 bold",
  className: o = "seatGroup-selector",
  icon: r
}) {
  const { t: c } = E(), { seatGroupList: d, fetchSeatGroupList: l } = us(e);
  B(() => {
    l();
  }, [l]);
  const [u, p] = $(!1), g = (h, b, C) => K(null, null, function* () {
    p(!1), l(), t && t(
      h,
      b,
      C
    );
  }), m = r ? { icon: r } : { noIcon: !0 }, _ = document.getElementById("modal-root");
  if (!_ && u !== !1)
    throw new Error('Unable to find element with id "modal-root"');
  return /* @__PURE__ */ S(H, { children: [
    /* @__PURE__ */ s(
      Zi,
      D(N({
        displayOnLeft: !0,
        action: /* @__PURE__ */ s(
          "button",
          {
            type: "button",
            className: "mpd-btn mpd-btn--secondary",
            onClick: () => p(!0),
            children: c("seat_group.selector.title")
          }
        ),
        label: a,
        labelClassName: i,
        className: o,
        disabled: !d
      }, m), {
        children: /* @__PURE__ */ S("div", { className: "seatGroup-selector__container", children: [
          d && d.size === 0 && /* @__PURE__ */ s("span", { children: c("no_category") }),
          d && d.map(
            (h, b) => /* @__PURE__ */ s(
              ds,
              {
                seatGroup: h,
                onClick: () => n(h),
                tabIndex: b
              },
              h["@id"]
            )
          )
        ] })
      })
    ),
    _ && u && d && Et(
      /* @__PURE__ */ s(
        Fi,
        {
          contractId: e,
          dataType: "SEAT_GROUP",
          coloredItemList: d,
          onCancel: () => p(!1),
          onChange: g
        }
      ),
      _
    )
  ] });
}
function Gn({
  onUpdateSeatGroups: e,
  contractId: n
}) {
  const t = U(), { t: a } = E(), i = Xt(), o = O(
    (r) => {
      i && i.find((c) => Yt(c) === G(r)) || t(pa(r.toJS()));
    },
    [t, i]
  );
  return /* @__PURE__ */ s(
    At.Provider,
    {
      value: q.getDefaultSerializerSdk(),
      children: /* @__PURE__ */ s(
        gs,
        {
          onSubmitAdminModal: e,
          onChange: o,
          labelClassName: "mpd-btn mpd-btn--primary mpd-color-white",
          className: "stock-contingent-button",
          contractId: n,
          label: a("seat_group.add_new_btn")
        }
      )
    }
  );
}
function ps(i) {
  var o = i, {
    className: e = "",
    children: n,
    selected: t = !1
  } = o, a = j(o, [
    "className",
    "children",
    "selected"
  ]);
  const r = nt("mpd-seating-sidebar-card", e, {
    selected: t
  });
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    /* @__PURE__ */ s("div", D(N({ className: r }, a), { children: n }))
  );
}
function On({
  tabs: e,
  className: n,
  onClose: t,
  onChangeTab: a
}) {
  const i = localStorage.getItem("seatingSelectedView"), [o, r] = $(
    i === '"seatGroup"' ? 1 : 0
  ), { sidebarAction: c } = e[o];
  return /* @__PURE__ */ S(
    pe,
    {
      action: c,
      className: nt("mpd-seating-tabbed-sidebar", n),
      onClose: t,
      children: [
        /* @__PURE__ */ s("div", { className: "mpd-seating-sidebar-tabs", children: e.map((d, l) => /* @__PURE__ */ s(
          ps,
          {
            onClick: () => {
              r(l), typeof a == "function" && a(d.name);
            },
            className: "p3",
            selected: o === l,
            children: d.label
          },
          `sidebar-tab-${d.name}`
        )) }),
        e[o].element
      ]
    }
  );
}
function Ss({ onError: e }) {
  var g;
  const n = te(), { t } = E(), a = U(), { eventDateId: i } = ke(), { isDrawing: o, setIsDrawing: r } = he(), c = Ze(), d = (g = c == null ? void 0 : c.map((m) => `/v1/seats/${m}`)) != null ? g : null, l = () => {
    n({ title: t("stock_gauge.update_error"), type: ve.ERROR }), window.setTimeout(() => {
      e();
    }, 5e3);
  }, u = () => {
    a(
      Sa(i, d, l)
    ), r(!1);
  }, p = () => {
    a(
      ma(i, d, l)
    ), r(!1);
  };
  return !o || !(c && c.size > 0) ? null : /* @__PURE__ */ S(H, { children: [
    /* @__PURE__ */ s(
      "button",
      {
        type: "button",
        className: "mpd-btn mpd-btn--primary",
        onClick: u,
        children: t("seating.dismiss_seat_cta")
      }
    ),
    /* @__PURE__ */ s(
      "button",
      {
        type: "button",
        className: "mpd-btn mpd-btn--secondary",
        onClick: p,
        children: t("seating.restore_seat_cta")
      }
    )
  ] });
}
function ms() {
  const { t: e } = E(), { isDrawing: n } = he(), t = Te(
    (i) => i.seating.get("selectedSeatIdSet")
  ), a = n && t && t.size > 0;
  return /* @__PURE__ */ S("div", { children: [
    /* @__PURE__ */ s("h3", { className: "mpd-seating-sidebar-header__title txtcenter", children: e(
      a ? "seating.gauge.sidebar.selection" : "seating.gauge.sidebar.title"
    ) }),
    !a && /* @__PURE__ */ s("div", { className: "stock-management-sidebar__help", children: e("seating.gauge.sidebar.help") }),
    a && /* @__PURE__ */ s("p", { className: "txtcenter", children: e("seating.move_seat.selected_seats", {
      count: t.size
    }) })
  ] });
}
function hs({ seatGroup: e, onSelect: n, isSelected: t, nbSeats: a }) {
  const { t: i } = E(), o = typeof n == "function";
  return /* @__PURE__ */ s(
    "div",
    {
      className: nt("seat-group-row", {
        "seat-group-row--selectable": o,
        "seat-group-row--selected": o && t
      }),
      onClick: () => o && n(e),
      "aria-hidden": "true",
      children: /* @__PURE__ */ S("div", { className: "seat-group-row__title", children: [
        /* @__PURE__ */ S("div", { className: "seat-group-row__icon-label", children: [
          /* @__PURE__ */ s(
            Se,
            {
              icon: "seat-filled",
              width: "14",
              height: "14",
              className: "ml1 mr2",
              color: e.seatColor || ha
            }
          ),
          /* @__PURE__ */ s("span", { className: "bold", children: e.label })
        ] }),
        i("seating.nb_seats", {
          count: a
        })
      ] }, e["@id"])
    }
  );
}
function Dn({ getNbSeats: e }) {
  const { t: n } = E(), { selectedSeatGroup: t, handleSelectSeatGroup: a } = ye(), i = Xt();
  return /* @__PURE__ */ S("div", { className: "stock-contingent-content", children: [
    /* @__PURE__ */ s("div", { className: "mpd-seating-sidebar-header", children: /* @__PURE__ */ s("h3", { className: "mpd-seating-sidebar-header__title pt0", children: n("seating.sidebar.seat_group.title") }) }),
    t === null && /* @__PURE__ */ s("p", { className: "mpd-seating-sidebar-header__help", children: n("seating.seat_group.sidebar.help.general") }),
    t !== null && /* @__PURE__ */ s("p", { className: "mpd-seating-sidebar-header__help", children: n("seating.seat_group.sidebar.help.select_seats") }),
    i ? /* @__PURE__ */ s("div", { children: i.map((o) => /* @__PURE__ */ s(
      hs,
      {
        nbSeats: e(o),
        seatGroup: o,
        isSelected: t !== null && t["@id"] === o["@id"],
        onSelect: a
      },
      o["@id"]
    )) }) : /* @__PURE__ */ s("div", { className: "p4 pt0 txtcenter", children: /* @__PURE__ */ s(tt, {}) })
  ] });
}
function bs() {
  const t = (bt() || A()).filter(
    (a) => a.status !== et
  ).groupBy(
    (a) => a.seatGroup ? G(a.seatGroup) : "noSeatGroup"
  );
  return /* @__PURE__ */ s(
    Dn,
    {
      getNbSeats: (a) => {
        var i, o;
        return (o = (i = t.get(a["@id"])) == null ? void 0 : i.count()) != null ? o : 0;
      }
    }
  );
}
function fs({ onError: e }) {
  const {
    selectStockContingent: n,
    unselectStockContingent: t,
    contractId: a,
    eventDateId: i
  } = ke(), { t: o } = E(), r = te(), c = U(), d = Zt() || A(), l = (p) => K(null, null, function* () {
    t();
    try {
      const g = yield q.getSdk().getRepository("stockContingent").create(
        new Xe({
          "@id": null,
          "@type": "StockContingent",
          eventDate: qe("/v1/event_dates/", i),
          contract: a,
          totalStock: 0,
          contingent: G(p),
          draft: !1
        }),
        { fields: Pn }
      );
      c({
        type: Jt,
        stockContingentList: d.push(g)
      }), c(Oe()), n(g);
    } catch (g) {
      console.error(g), r({
        title: o("stock_contingent.update_error"),
        type: ve.ERROR
      }), window.setTimeout(() => {
        e();
      }, 5e3);
    }
  });
  if (!a)
    return null;
  const u = d.map(
    (p) => G(p.contingent)
  );
  return /* @__PURE__ */ s(
    At.Provider,
    {
      value: q.getDefaultSerializerSdk(),
      children: /* @__PURE__ */ s(
        Ln,
        {
          onChange: l,
          labelClassName: "mpd-btn mpd-btn--primary mpd-color-white",
          className: "stock-management-sidebar__actionButton",
          contractId: a,
          label: o("stock_contingent.add_new_btn"),
          isContingentHidden: (p) => u.includes(G(p))
        }
      )
    }
  );
}
function Cs(e) {
  const { nbActiveSeats: n, stockContingentList: t } = e;
  M(t, "eventDate.stockContingentList"), M(n, "eventDate.nbActiveSeats");
  const a = t.reduce(
    (i, o) => {
      var r;
      return i + ((r = o.totalStock) != null ? r : 0);
    },
    0
  );
  return n - a;
}
function Rn({
  isDeleting: e,
  onCancel: n,
  onConfirm: t,
  contingentEntity: a
}) {
  const { t: i } = E();
  return /* @__PURE__ */ s(
    In,
    {
      title: i("modal.delete_stock_contingent.title"),
      onCancel: n,
      primaryButtonProps: {
        onClick: () => t(a),
        isLoading: e
      },
      secondaryButtonProps: {
        onClick: n
      },
      children: /* @__PURE__ */ s(
        "div",
        {
          className: "txtcenter",
          dangerouslySetInnerHTML: {
            __html: i("modal.delete_stock_contingent.text")
          }
        }
      )
    }
  );
}
function _s({ onError: e }) {
  var v;
  const {
    selectedStockContingent: n,
    selectStockContingent: t,
    unselectStockContingent: a,
    eventDateId: i
  } = ke(), { t: o } = E(), r = te(), c = U(), d = ht();
  f(d, "eventDate");
  const l = Zt() || A(), u = Ze(), [p, g] = $(null), [m, _] = $(!1), [h, b] = $(!1), C = Cs(d);
  M(d.issuedTickets, "eventDate.issuedTickets"), M(d.bookedTickets, "eventDate.bookedTickets");
  const k = d.issuedTickets + d.bookedTickets - l.reduce((T, w) => (M(
    w.bookedTickets,
    "contingent.bookedTickets"
  ), T + w.bookedTickets), 0), y = document.getElementById("modal-root"), L = () => {
    _(!1), b(!1), g(null);
  }, I = (T) => K(null, null, function* () {
    _(!0), a();
    try {
      yield q.getSdk().getRepository("stockContingent").delete(T), c(Oe()), c(en(i, L));
    } catch (w) {
      console.error(w);
      const R = yield xe(w);
      r({
        title: R,
        type: ve.ERROR
      }), window.setTimeout(() => {
        e();
      }, 5e3), L();
    }
  }), x = (T) => {
    const w = l == null ? void 0 : l.get(T);
    w && ((n == null ? void 0 : n["@id"]) === w["@id"] ? (a(), c(Z(V()))) : (t(w), M(
      w.availableSeatList,
      "selectedStockContingent.availableSeatList"
    ), Nn(
      w.availableSeatList,
      "selectedStockContingent.availableSeatList"
    ), c(
      ba(w.availableSeatList)
    )));
  };
  return /* @__PURE__ */ S(H, { children: [
    /* @__PURE__ */ S("div", { className: "stock-management-sidebar__content", children: [
      /* @__PURE__ */ s("h3", { className: "mpd-seating-sidebar-header__title", children: o("seating.stock_contingent.sidebar.title") }),
      !n && /* @__PURE__ */ s("p", { className: "mpd-seating-sidebar-header__help", children: o("seating.stock_contingent.sidebar.help.general") }),
      n && (u && u.size === 0 || n.totalStock === null) && /* @__PURE__ */ s("p", { className: "mpd-seating-sidebar-header__help", children: o("seating.stock_contingent.sidebar.help.select_seats") }),
      C > 0 && /* @__PURE__ */ s("div", { className: "stock-management-sidebar__item", children: /* @__PURE__ */ s(
        zi,
        {
          totalStock: C,
          availableStock: (v = d.notInStockContingentBookableStock) != null ? v : 0,
          bookedStock: k
        }
      ) }),
      (l || A()).map((T, w) => /* @__PURE__ */ s(
        pt,
        {
          disabled: m && (p == null ? void 0 : p.get("@id")) === T.get("@id"),
          index: w,
          onDeleteStockContingent: (R) => (g(R), R.total ? b(!0) : I(R)),
          stockContingent: T,
          onSelect: (R, X) => x(X),
          isSelected: T["@id"] === (n == null ? void 0 : n["@id"]),
          hasEventDate: !!d
        },
        T.get("@id") ? T.get("@id") : w
      ))
    ] }),
    y && p && h && Et(
      /* @__PURE__ */ s(
        Rn,
        {
          isDeleting: m,
          onConfirm: I,
          onCancel: () => L(),
          contingentEntity: p
        }
      ),
      y
    )
  ] });
}
function vs({ onTabChange: e, onError: n }) {
  const { t } = E(), { selectTab: a, contractId: i } = ke();
  return /* @__PURE__ */ s(
    On,
    {
      className: "stock-management-sidebar",
      onChangeTab: (o) => {
        e(o), a(o);
      },
      tabs: [
        {
          name: P.CONTINGENT,
          label: t("seating.sidebar_tab.contingent.title"),
          element: /* @__PURE__ */ s(_s, { onError: n }),
          sidebarAction: /* @__PURE__ */ s(fs, { onError: n })
        },
        {
          name: P.SEAT_GROUP,
          label: t("seating.sidebar_tab.seat_group.title"),
          element: /* @__PURE__ */ s(bs, {}),
          sidebarAction: /* @__PURE__ */ s(Gn, { contractId: i })
        },
        {
          name: P.GAUGE,
          label: t("seating.sidebar_tab.gauge.title"),
          element: /* @__PURE__ */ s(ms, {}),
          sidebarAction: /* @__PURE__ */ s(Ss, { onError: n })
        }
      ]
    }
  );
}
function Mn(r) {
  var c = r, {
    isSelected: e,
    isSelectable: n,
    seatId: t,
    bookingStatus: a,
    color: i
  } = c, o = j(c, [
    "isSelected",
    "isSelectable",
    "seatId",
    "bookingStatus",
    "color"
  ]);
  return /* @__PURE__ */ s(
    re,
    D(N({}, o), {
      seatId: t,
      isSelectable: n,
      bookingStatus: a,
      displayDismissedSeat: !0,
      icon: be(a, !1),
      fill: i,
      isSelected: e
    })
  );
}
Mn.displayName = "StockManagementSeat";
const ks = de(Mn);
function Ls(e, n) {
  const { selectedStockContingent: t, selectedTab: a, eventDateId: i } = ke(), { setIsDrawing: o } = he(), r = tn(), c = te(), { t: d } = E(), l = U(), u = Ze(), p = we(
    t == null ? void 0 : t.get("@id")
  ), g = we(u), m = O(() => K(null, null, function* () {
    var _;
    if (t)
      try {
        const h = A(
          r.map((b) => b["@id"])
        );
        yield q.getSdk().getRepository("stockContingent").update(
          t.merge({
            totalStock: (_ = h.size) != null ? _ : 0,
            availableSeatList: h || A(),
            seatList: t.seatList || A(),
            eventDate: qe("/v1/event_dates/", i),
            contingent: G(t.contingent)
          }),
          { fields: Pn }
        ), l(en(i)), o(!1), n && n(
          r.some(
            (b) => b.bookingStatus === ne.IN_CART
          )
        );
      } catch (h) {
        console.error(h), xe(h).then((b) => {
          c({
            title: d("stock_management.error.seat_group_update_error"),
            message: b,
            type: ve.ERROR
          });
        }), window.setTimeout(() => {
          e();
        }, 5e3);
      }
  }), [
    l,
    i,
    e,
    r,
    t,
    o,
    d,
    c,
    n
  ]);
  B(() => {
    if (a !== P.CONTINGENT)
      return;
    !(g != null && g.equals(u)) && p && t && // avoid save when contingent is just selected
    p === t.get("@id") && m();
  }, [
    a,
    u,
    t,
    p,
    m,
    g
  ]);
}
function Ns() {
  const { t: e } = E(), { selectedTab: n } = ke(), t = te(), a = tn(), i = U(), o = Ze(), { selectedSeatGroup: r } = ye(), c = we(o), { setIsDrawing: d } = he();
  B(() => {
    if (n !== P.SEAT_GROUP || !r)
      return;
    if (!(c != null && c.equals(o)) && o && o.size) {
      const u = a.map((p) => ({
        "@id": p["@id"],
        seatGroup: r["@id"]
      })).toArray();
      q.getSdk().getRepository("availableSeat").putBulk({ "hydra:member": u }, [
        "@id",
        "seatGroup"
      ]).then((p) => p.json()).then(
        (p) => {
          i(fa(p["hydra:member"])), i(Oe()), d(!1);
        }
      ).catch((p) => {
        console.error(p), xe(p).then((g) => {
          t({
            title: e("stock_management.error.seat_group_update_error"),
            message: g
          });
        });
      });
    }
  }, [
    i,
    c,
    a,
    r,
    o,
    n,
    d,
    e,
    t
  ]);
}
function Is({
  seatConfigBlockList: e,
  onGetSelectableSeats: n,
  onError: t,
  onStockChanged: a
}) {
  const { selectedStockContingent: i, selectedTab: o } = ke(), { selectedSeatGroup: r } = ye(), { setSvgDrawerRef: c } = he(), d = te(), { t: l } = E(), u = U();
  Ls(t, a), Ns();
  const p = O(
    (m, _, h) => K(null, null, function* () {
      if (!h)
        return;
      const b = Ae(m);
      o === P.CONTINGENT && i ? u(_ ? ft(b) : Qe(b)) : o === P.SEAT_GROUP && r ? u(Qe(b)) : o === P.GAUGE && (u(Z(V([b]))), yield u(
        Ca(m, () => {
          d({
            title: l("stock_gauge.update_error"),
            type: ve.ERROR
          }), window.setTimeout(() => {
            t();
          }, 5e3);
        })
      ), a && a(!1), u(Oe()));
    }),
    [
      u,
      t,
      r,
      i,
      o,
      l,
      d,
      a
    ]
  ), g = o === P.CONTINGENT && i || o === P.SEAT_GROUP && r || o === P.GAUGE;
  return /* @__PURE__ */ s("div", { className: "mpd-seating__app__event-svg-wrapper", ref: c, children: /* @__PURE__ */ s(
    ce,
    {
      seatEntityType: "AvailableSeat",
      SeatElement: ks,
      getSelectableSeatIdSet: (m, _) => n(m, _, i),
      onClickSeat: p,
      seatConfigBlockList: e,
      isMovingSeat: !1,
      actionButtons: g && /* @__PURE__ */ s(Ct, {}),
      isPdfDownloadAvailable: !0
    }
  ) });
}
const Wt = {
  [P.CONTINGENT]: {
    getSelectableSeats: Ta,
    initData: Ia
  },
  [P.SEAT_GROUP]: {
    getSelectableSeats: Na,
    initData: La
  },
  [P.GAUGE]: {
    getSelectableSeats: ka,
    initData: va
  }
};
function Ts({
  eventDateId: e,
  onStockChanged: n
}) {
  const t = nn(), a = U();
  B(() => () => {
    a(me());
  }, [a]);
  const i = Te(an), o = fe(t.getState()) && _a(t.getState()), { onSelectView: r } = De(), [c, d] = $(P.CONTINGENT), l = localStorage.getItem("seatingSelectedView") === '"seatGroup"' ? P.SEAT_GROUP : P.CONTINGENT, u = O(
    (g = !1) => {
      a(Wt[c].initData({ eventDateId: e, hasError: g }));
    },
    [c, a, e]
  );
  B(() => {
    u();
  }, [u]);
  const p = (g) => {
    d(g), g === P.SEAT_GROUP && r(ae.SeatGroup), g === P.CONTINGENT && r(ae.Contingent), a(Oe());
  };
  if (!o)
    return /* @__PURE__ */ s(ue, {});
  if (!i)
    throw new Error(
      "SeatConfig should be set in store. Maybe you forgot to check that `app.loadStatus.seatConfigData` is set"
    );
  return /* @__PURE__ */ s(yn, { children: /* @__PURE__ */ s(ls, { initialTab: l, children: /* @__PURE__ */ s(
    "div",
    {
      className: "mpd-seating__app context-stock-management",
      id: "mpd-seating__app",
      children: /* @__PURE__ */ S("div", { className: "mpd-seating__app__container", children: [
        /* @__PURE__ */ s(
          Is,
          {
            onStockChanged: n,
            seatConfigBlockList: i.seatConfigBlockList,
            onGetSelectableSeats: Wt[c].getSelectableSeats,
            onError: () => u(!0)
          }
        ),
        /* @__PURE__ */ s(
          vs,
          {
            onTabChange: p,
            onError: () => u(!0)
          }
        )
      ] })
    }
  ) }) });
}
function As() {
  return /* @__PURE__ */ s("div", { className: "mpd-seating__app__event-caption", children: /* @__PURE__ */ S("div", { className: "mpd-seating__app__event", children: [
    /* @__PURE__ */ s("div", { className: "mpd-seating__app__event-title", children: " " }),
    /* @__PURE__ */ s("div", { className: "mpd-seating__app__event-date", children: " " })
  ] }) });
}
function Es({
  eventDate: e
}) {
  if (e === null || !e.ticketing)
    return null;
  const n = Aa.getMoment(), { ticketing: t, startDate: a, endDate: i } = e, { timezone: o, title: r } = t;
  let c = null, d = null;
  return a && (c = n.utc(a).tz(o)), i && (d = n.utc(i).tz(o)), /* @__PURE__ */ s("div", { className: "mpd-seating__app__event-caption", children: /* @__PURE__ */ S("div", { className: "mpd-seating__app__event", children: [
    /* @__PURE__ */ s("div", { className: "mpd-seating__app__event-title", children: r }),
    /* @__PURE__ */ s("div", { className: "mpd-seating__app__event-date", children: /* @__PURE__ */ s(
      Wi,
      {
        startDate: c,
        endDate: d
      }
    ) })
  ] }) });
}
function at() {
  const e = ht();
  return e ? /* @__PURE__ */ s(Es, { eventDate: e }) : /* @__PURE__ */ s(As, {});
}
const Bn = Ce(null);
function xn() {
  return _e(Bn);
}
function Vn({
  cart: e,
  children: n
}) {
  return /* @__PURE__ */ s(Bn.Provider, { value: e, children: n });
}
function Un({
  selectedSeatIdSet: e,
  nbSeatsInBooking: n,
  cartOrOrder: t
}) {
  var c, d;
  const { t: a } = E(), i = e && e.size || 0;
  let o = null;
  const r = (l) => {
    l.participant && (f(l.participant, "item.participant"), o = Ve(l.participant));
  };
  if (i === 1) {
    const l = e == null ? void 0 : e.values().next().value.toString();
    if (sn(t)) {
      const u = (c = t == null ? void 0 : t.ticketList) == null ? void 0 : c.find((p) => (f(p, "ticket"), p.availableSeat ? (f(p.availableSeat, "ticket.availableSeat"), f(
        p.availableSeat.seat,
        "ticket.availableSeat.seat"
      ), Y(
        p.availableSeat.seat["@id"],
        "ticket.availableSeat.seat.id"
      ), Q(p.availableSeat.seat["@id"]) === l) : !1));
      u && (f(u, "foundTicket"), r(u));
    } else if (on(t)) {
      const u = (d = t == null ? void 0 : t.cartItemList) == null ? void 0 : d.find((p) => {
        if (f(p, "cartItem"), !p.seatList || p.seatList.size === 0)
          return !1;
        Nn(p.seatList, "cartItem.seatList");
        const g = p.seatList.first();
        return Y(g, "cartItem.seatList.first"), Q(g) === l;
      });
      u && (f(u, "foundCartItem"), r(u));
    }
  }
  return /* @__PURE__ */ S("div", { className: "replacement-sidebar__replacement-caption", children: [
    /* @__PURE__ */ S("div", { className: "mb3", children: [
      /* @__PURE__ */ s("div", { className: "larger", children: a("seating.move_seat.selected_seats", {
        count: i
      }) }),
      o && /* @__PURE__ */ s("div", { className: "mpd-color-gray mt1 mb1", children: o }),
      /* @__PURE__ */ s("div", { className: "smaller", children: a("seating.move_seats.nb_seats_in_order", {
        count: n
      }) })
    ] }),
    i > 0 && /* @__PURE__ */ s("p", { className: "small mt0", children: a("seating.help_move_seats", { count: i }) })
  ] });
}
function Fn({ entity: e }) {
  var c;
  if (typeof e.customer == "string")
    throw new rn(
      "entity.customer must be either null or an object"
    );
  const n = Ve(e.customer), { nationalPhoneNumber: t } = Ki(
    (c = e.customer) == null ? void 0 : c.phone
  ), a = e.customer && (!!n || e.customer.phone), i = e instanceof qi ? e.reservationName : e.description;
  let o, r = !0;
  return a ? o = /* @__PURE__ */ s("span", { children: /* @__PURE__ */ s("div", { className: "mpd-seating-booking-tile__customer-fullname larger bold", children: n }) }) : i && (o = /* @__PURE__ */ s("span", { children: i }), r = !1), /* @__PURE__ */ S("div", { children: [
    o && /* @__PURE__ */ s("header", { className: "mpd-table__cell-header", children: o }),
    /* @__PURE__ */ S("article", { className: "mpd-table__cell-description", children: [
      r && !!i && /* @__PURE__ */ s("div", { children: i }),
      !!t && /* @__PURE__ */ s("div", { children: t })
    ] })
  ] });
}
function ys({ cart: e }) {
  var i, o, r;
  const { t: n } = E(), t = (i = e.createdAt) == null ? void 0 : i.format("LL, LT");
  M(e.retailValue, "cart.retailValue"), M(e.currency, "cart.currency");
  const a = oe(e.retailValue, e.currency);
  return /* @__PURE__ */ S("section", { className: "mpd-seating-booking-tile__container", children: [
    /* @__PURE__ */ s(Fn, { entity: e }),
    /* @__PURE__ */ S("div", { children: [
      /* @__PURE__ */ S("div", { className: "txtcenter", children: [
        e.type === St.RESERVATION && n("sales.reservation", { number: e.getShortId() }),
        e.type === St.CART && n("sales.carts", { number: e.getShortId() })
      ] }),
      /* @__PURE__ */ s("div", { className: "txtcenter help small", children: t })
    ] }),
    /* @__PURE__ */ S("div", { className: "mpd-seating-booking-tile__ticket_coupon_details mt2", children: [
      /* @__PURE__ */ s("header", { className: "mpd-table__cell-header txtcenter", children: a }),
      /* @__PURE__ */ s("article", { className: "mpd-table__cell-description", children: e.nbTickets !== 0 && n("order.nb_tickets", {
        count: (o = e.nbTickets) != null ? o : 0
      }) })
    ] }),
    e.comment !== null && /* @__PURE__ */ S("div", { className: "mpd-seating-booking-tile__comment", children: [
      n("order.comment"),
      " ",
      e.comment
    ] }),
    /* @__PURE__ */ S("div", { className: "mpd-seating-booking-tile__origin", children: [
      n("sales.list_header.origin"),
      " ",
      n("order.origin", { name: (r = e == null ? void 0 : e.originType) == null ? void 0 : r.toLowerCase() })
    ] })
  ] });
}
function Ps({
  seatConfig: e,
  selectedSeatIdSet: n,
  cart: t
}) {
  return /* @__PURE__ */ s("div", { className: "mpd-seating__order-sidebar", children: /* @__PURE__ */ S("div", { className: "replacement-sidebar__content", children: [
    /* @__PURE__ */ s("div", { className: "replacement-sidebar__name", children: e.label }),
    /* @__PURE__ */ s("hr", {}),
    /* @__PURE__ */ s("div", { children: /* @__PURE__ */ s(
      Un,
      {
        cartOrOrder: t,
        selectedSeatIdSet: n,
        nbSeatsInBooking: Ee(t).size
      }
    ) }),
    /* @__PURE__ */ s("table", { className: "mpd-table mpd-table--narrow mt0", children: /* @__PURE__ */ s("tbody", { children: t && /* @__PURE__ */ s(ys, { cart: t }) }) })
  ] }) });
}
function ws(e, n) {
  return e && n ? "both" : n ? "contingent" : "category";
}
function $n({
  onCancel: e,
  onConfirm: n,
  newCategory: t,
  oldCategory: a,
  newContingent: i,
  oldContingent: o
}) {
  const { t: r } = E(), l = ws(
    t !== a,
    i !== o
  );
  return /* @__PURE__ */ s(
    In,
    {
      onCancel: e,
      title: r("modal.replacement.title", { replacementType: l }),
      primaryButtonProps: {
        onClick: () => {
          n(), e();
        }
      },
      secondaryButtonProps: {
        onClick: e
      },
      children: /* @__PURE__ */ S("div", { className: "txtcenter", children: [
        /* @__PURE__ */ s("p", { children: r("modal.replacement.message", {
          replacementType: l,
          oldCategory: a,
          newCategory: t,
          oldContingent: o,
          newContingent: i
        }) }),
        l !== "contingent" && /* @__PURE__ */ s("p", { className: "mpd-color-gray", children: r("modal.other_category.note") })
      ] })
    }
  );
}
const zn = de(
  (c) => {
    var d = c, {
      color: e,
      isSelectable: n,
      isSelected: t,
      bookingStatus: a,
      seatEntity: i,
      isDesk: o
    } = d, r = j(d, [
      "color",
      "isSelectable",
      "isSelected",
      "bookingStatus",
      "seatEntity",
      "isDesk"
    ]);
    const l = xn(), u = !!(l && Ee(l).find((p) => p["@id"] === i["@id"]));
    return /* @__PURE__ */ s(
      re,
      D(N({}, r), {
        isDesk: o,
        seatEntity: i,
        isSelectable: n,
        bookingStatus: a,
        icon: be(a, u),
        fill: !n && !o ? Re : e,
        isSelected: t || u,
        isZoomed: t
      })
    );
  }
);
zn.displayName = "CartReplacementSeat";
function Gs(e, n) {
  return K(this, null, function* () {
    return q.getSdk().getRepository("cart").find(e, {
      fields: _t
    }).then((a) => vt(
      a,
      `/v1/event_dates/${n}`
    ));
  });
}
function Wn(e, n, t) {
  const [a, i] = $(null), o = U();
  B(() => {
    Gs(e, n).then((c) => {
      const d = Ee(c);
      o(
        He(
          // @ts-expect-error AvailableSeatType and AvailableSeat are the same
          t && (t == null ? void 0 : t.size) > 0 ? t : d
        )
      ), i(c);
    });
  }, [e, t, o, n]);
  const r = O(
    (c, d) => {
      if (!a)
        return;
      const l = a.update("cartItemList", (u) => (z(u, "cartItemList"), u.map((p) => p.update("availableSeatList", (g) => g && (z(
        g,
        "availableSeatList"
      ), g.map(
        (_) => _["@id"] === c["@id"] ? d : _
      ))))));
      i(l);
    },
    [a]
  );
  return [a, r];
}
var lt, Ne;
let Os = (lt = class extends Be {
  constructor(t) {
    super(t);
    // eslint-disable-next-line react/sort-comp
    ot(this, Ne);
    this.state = {
      isReplacementWarningModalOpened: !1,
      newCategory: null,
      oldCategory: null,
      newContingent: null,
      oldContingent: null,
      selectedSeat: null
    }, this.init = this.init.bind(this), this.setRef = this.setRef.bind(this), this.selectOrMoveSeat = this.selectOrMoveSeat.bind(this), this.toggleSelectAllSeat = this.toggleSelectAllSeat.bind(this), rt(this, Ne, new cn({
      // eslint-disable-next-line react/destructuring-assignment
      selectBatchOfSeats: this.props.selectBatchOfSeats
    }));
  }
  componentDidMount() {
    this.init();
  }
  componentDidUpdate(t) {
    var i;
    const { selectedSeatIdSet: a } = this.props;
    (i = t.selectedSeatIdSet) != null && i.equals(a) || Pe(this, Ne).handleSelectedSeatIdListChange(a);
  }
  componentWillUnmount() {
    const { resetState: t } = this.props;
    t();
  }
  setRef(t) {
    t && Pe(this, Ne).init();
  }
  init() {
    const { cartId: t, eventDateId: a, initCartReplacement: i } = this.props;
    i(t, a);
  }
  selectOrMoveSeat(t, a, i) {
    var h, b;
    const {
      selectedSeatIdSet: o,
      toast: r,
      selectOrMoveSeat: c,
      cart: d,
      replaceAvailableSeat: l,
      t: u
    } = this.props, { isReplacementWarningModalOpened: p } = this.state, g = o == null ? void 0 : o.first();
    if (!d || !i)
      return;
    const m = ln(t);
    if (!(!m && Ea(t, d, g)) || p || !g) {
      const C = Ae(t);
      c(
        d,
        C,
        i,
        m,
        null,
        l,
        this.init,
        r,
        u
      ), this.setState({
        isReplacementWarningModalOpened: !1,
        oldCategory: null,
        newCategory: null,
        oldContingent: null,
        newContingent: null
      });
    } else {
      const C = ya(d, g);
      M(C, "availableSeat"), f(
        C.seatGroup,
        "availableSeat.seatGroup"
      ), f(t.seatGroup, "seatEntity.seatGroup"), F(
        C.stockContingent,
        "availableSeat.stockContingent"
      ), F(
        t.stockContingent,
        "seatEntity.stockContingent"
      );
      const k = C.stockContingent, y = t.stockContingent, L = k && typeof k == "object" ? k.contingent : null, I = y && typeof y == "object" ? y.contingent : null;
      F(L, "stockContingent.contingent"), F(I, "stockContingent.contingent");
      const x = L && typeof L == "object" && (h = L.name) != null ? h : u("seating.contingent.no-contingent"), v = I && typeof I == "object" && (b = I.name) != null ? b : u("seating.contingent.no-contingent");
      this.setState({
        oldCategory: C.seatGroup.label,
        newCategory: t.seatGroup.label,
        oldContingent: x,
        newContingent: v
      }), this.setState({
        selectedSeat: t,
        isReplacementWarningModalOpened: !0
      });
    }
  }
  toggleSelectAllSeat() {
    const { dispatch: t, cart: a, selectedSeatIdSet: i } = this.props;
    M(a);
    const o = Vt(a);
    if (i && i.size === o.size)
      t(Z(V()));
    else {
      const c = o.map((d) => {
        const l = d.get("seat");
        return f(l), Number(l.getShortId());
      }).toSet();
      t(Z(c));
    }
  }
  render() {
    const {
      selectedSeatIdSet: t,
      getSelectableSeatIdSet: a,
      isReady: i,
      seatConfig: o,
      onDismissSeating: r,
      cart: c,
      t: d,
      onConfirmAction: l,
      externalActions: u
    } = this.props, {
      isReplacementWarningModalOpened: p,
      oldCategory: g,
      newCategory: m,
      oldContingent: _,
      newContingent: h,
      selectedSeat: b
    } = this.state;
    if (!i)
      return /* @__PURE__ */ s(ue, {});
    if (!o)
      throw new Error("Unable to find seatConfig. This should not happen.");
    return /* @__PURE__ */ s(
      "div",
      {
        className: "mpd-seating__app context-reservation",
        id: "mpd-seating__app",
        children: /* @__PURE__ */ S("div", { className: "mpd-seating__app__container", ref: this.setRef, children: [
          /* @__PURE__ */ S("div", { className: "mpd-seating__app__event-svg-wrapper", children: [
            /* @__PURE__ */ s(at, {}),
            /* @__PURE__ */ s(
              ce,
              {
                seatEntityType: "AvailableSeat",
                SeatElement: zn,
                isMovingSeat: !!(t && t.size > 0),
                getSelectableSeatIdSet: (C, k) => c ? a(C, k, c) : V(),
                onClickSeat: this.selectOrMoveSeat,
                seatConfigBlockList: o ? o.seatConfigBlockList : [],
                externalActions: u
              }
            )
          ] }),
          /* @__PURE__ */ s(
            pe,
            {
              onClose: r,
              action: /* @__PURE__ */ S(H, { children: [
                /* @__PURE__ */ s(
                  "button",
                  {
                    type: "button",
                    className: "mpd-btn",
                    onClick: this.toggleSelectAllSeat,
                    children: c && t && t.size === Vt(c).size ? d("cart_replacement.deselect_all") : d("cart_replacement.select_all")
                  }
                ),
                l && /* @__PURE__ */ s(
                  "button",
                  {
                    type: "button",
                    className: "mpd-btn mpd-btn--primary",
                    onClick: l,
                    children: d("cart_replacement.confirm")
                  }
                )
              ] }),
              children: c && /* @__PURE__ */ s(
                Ps,
                {
                  seatConfig: o,
                  selectedSeatIdSet: t,
                  cart: c
                }
              )
            }
          ),
          p && /* @__PURE__ */ s(
            $n,
            {
              oldCategory: g,
              newCategory: m,
              oldContingent: _,
              newContingent: h,
              onCancel: () => this.setState({
                isReplacementWarningModalOpened: !1,
                oldCategory: null,
                newCategory: null,
                oldContingent: null,
                newContingent: null
              }),
              onConfirm: () => {
                b && this.selectOrMoveSeat(b, !0, !0);
              }
            }
          )
        ] })
      }
    );
  }
}, Ne = new WeakMap(), st(lt, "defaultProps", {
  onDismissSeating: null,
  onConfirmAction: null
}), lt);
function Ds(e) {
  const { cartId: n, eventDateId: t, defaultSelectedSeatIdList: a } = e, i = te(), [o, r] = Wn(
    n,
    t,
    a
  ), { t: c } = E(), d = U();
  return /* @__PURE__ */ s(Vn, { cart: o, children: /* @__PURE__ */ s(
    Os,
    D(N({}, e), {
      cart: o,
      replaceAvailableSeat: r,
      toast: i,
      t: c,
      dispatch: d
    })
  ) });
}
const Rs = (e) => ({
  seatConfig: e.seating.get("seatConfig"),
  isReady: fe(e),
  getSelectableSeatIdSet: Lt,
  selectedSeatIdSet: e.seating.get("selectedSeatIdSet")
}), Ms = {
  initCartReplacement: dn,
  selectBatchOfSeats: Z,
  selectOrMoveSeat: kt,
  resetState: me
}, Bs = se(
  Rs,
  Ms
)(Ds), xs = {
  selectedContingent: null,
  setSelectedContingent: () => null,
  handleChangePane: () => null,
  currentPane: P.CONTINGENT,
  displayDrawButton: !1,
  handleSelectContingent: () => null
}, Kn = Ce(xs), jn = () => _e(Kn);
function Vs({
  children: e
}) {
  const [n, t] = $(
    P.CONTINGENT
  ), [a, i] = $(null), { selectedSeatGroup: o, unselectSeatGroup: r } = ye(), { onSelectView: c } = De(), d = O(
    (g) => {
      switch (g) {
        case P.CONTINGENT:
          c(ae.Contingent);
          break;
        case P.SEAT_GROUP:
          c(ae.SeatGroup);
          break;
      }
      i(null), r(), t(g);
    },
    [c, r]
  ), l = O(
    (g) => {
      a && G(g) === G(a) ? i(null) : i(g);
    },
    [a]
  ), u = n === P.CONTINGENT && a !== null || n === P.SEAT_GROUP && o !== null || n === P.GAUGE, p = Me(
    () => ({
      selectedContingent: a,
      setSelectedContingent: i,
      handleChangePane: d,
      currentPane: n,
      displayDrawButton: u,
      handleSelectContingent: l
    }),
    [
      n,
      u,
      d,
      l,
      a
    ]
  );
  return /* @__PURE__ */ s(Kn.Provider, { value: p, children: e });
}
function Us({
  selectedSeatIdListHash: e,
  onSelectedIdListChange: n,
  onUnSelectedContingent: t,
  selectBatchOfSeats: a,
  onUpdateContingentSeatList: i,
  removeAvailableSeatModelListContingent: o,
  updateStatus: r,
  contingentList: c,
  removeContingent: d
}) {
  const { t: l } = E(), { selectedContingent: u, setSelectedContingent: p, handleSelectContingent: g } = jn(), { onSelectView: m } = De(), [_, h] = $(null);
  B(() => {
    a(V()), u || t();
  }, [t, u, a]);
  const b = u == null ? void 0 : u.get("@id"), C = we(u == null ? void 0 : u.get("@id"));
  B(() => {
    function L(I) {
      return K(this, null, function* () {
        yield i(I), n(), m(ae.Contingent), a(V());
      });
    }
    e && b && C === b && L(b);
  }, [e]);
  const k = O(
    (L) => K(null, null, function* () {
      const I = G(L);
      Y(I, "contingentId"), c.findIndex(
        (v) => G(v) === I
      ) !== -1 && (yield o(I), d(I), h(null), p(null), a(V()));
    }),
    [
      c,
      o,
      d,
      a,
      p
    ]
  ), y = document.getElementById("modal-root");
  if (!y && _ !== null)
    throw new Error('Unable to find element with id "modal-root"');
  return /* @__PURE__ */ S(H, { children: [
    /* @__PURE__ */ S("div", { className: "stock-contingent-content", children: [
      /* @__PURE__ */ s("div", { className: "mpd-seating-sidebar-header", children: /* @__PURE__ */ s("h3", { className: "mpd-seating-sidebar-header__title pt0", children: l("seating.sidebar.contingent.title") }) }),
      u === null && /* @__PURE__ */ s("p", { className: "mpd-seating-sidebar-header__help", children: l("seating.stock_contingent.sidebar.help.general") }),
      u !== null && /* @__PURE__ */ s("p", { className: "mpd-seating-sidebar-header__help", children: l("seating.stock_contingent.sidebar.help.select_seats") }),
      c ? /* @__PURE__ */ S("div", { children: [
        /* @__PURE__ */ s(
          pt,
          {
            index: -1,
            stockContingent: new Xe({
              "@id": "/v1/stock_contingents/999",
              "@type": "StockContingent",
              contingent: new Qi({
                "@id": "/v1/contingents/999",
                "@type": "Contingent",
                name: l("seating.contingent.no-contingent")
              })
            }),
            isSelected: !1,
            hasEventDate: !1
          },
          "no-contingent"
        ),
        c.map((L, I) => {
          const x = L.get("@id");
          return Y(x, "contingentId"), /* @__PURE__ */ s(
            pt,
            {
              index: I,
              onDeleteStockContingent: (v) => {
                f(
                  v.contingent,
                  "stockContingent.contingent"
                ), h(v.contingent);
              },
              stockContingent: new Xe({
                "@id": `/v1/stock_contingents/${Number(x)}`,
                "@type": "StockContingent",
                contingent: L
              }),
              onSelect: (v) => {
                f(
                  v.contingent,
                  "stockContingent.contingent"
                ), g(v.contingent);
              },
              isSelected: G(u) === G(L),
              hasEventDate: !1
            },
            L.get("@id")
          );
        })
      ] }) : /* @__PURE__ */ s("div", { className: "p4 pt0 txtcenter", children: /* @__PURE__ */ s(tt, {}) })
    ] }),
    y && _ !== null && Et(
      /* @__PURE__ */ s(
        Rn,
        {
          isDeleting: r === "IN_PROGRESS",
          onConfirm: k,
          onCancel: () => h(null),
          contingentEntity: _
        }
      ),
      y
    )
  ] });
}
const Fs = (e) => ({
  selectedSeatIdListHash: un(e),
  updateStatus: e.seating.getIn([
    "updatingAvailableSeatModelList-fetch-status",
    "status"
  ]) || null,
  contingentList: e.seating.get("contingentList") || A()
}), $s = {
  selectBatchOfSeats: Z,
  onUpdateContingentSeatList: pn,
  removeAvailableSeatModelListContingent: gn,
  removeContingent: Pa
}, zs = se(
  Fs,
  $s
)(Us);
function Ws({
  onSelectedIdListChange: e,
  onUnselectSeatGroup: n,
  selectBatchOfSeats: t,
  updateAvailableSeatModelListSeatGroup: a,
  availableSeatModelList: i,
  selectedSeatIdListHash: o
}) {
  const { selectedSeatGroup: r } = ye(), { onSelectView: c } = De();
  B(() => {
    t(V()), r || n();
  }, [n, r, t]);
  const d = r == null ? void 0 : r["@id"], l = we(r == null ? void 0 : r["@id"]);
  B(() => {
    function g(m) {
      return K(this, null, function* () {
        yield a(m), e(), c(ae.SeatGroup), t(V());
      });
    }
    o && d && l === d && g(d);
  }, [o]);
  const p = i.filter(
    (g) => g.status !== et
  ).groupBy(
    (g) => g.seatGroup ? Yt(g.seatGroup) : "noSeatGroup"
  );
  return /* @__PURE__ */ s(
    Dn,
    {
      getNbSeats: (g) => {
        var m, _;
        return (_ = (m = p.get(g["@id"])) == null ? void 0 : m.count()) != null ? _ : 0;
      }
    }
  );
}
const Ks = (e) => ({
  selectedSeatIdListHash: un(e),
  availableSeatModelList: e.seating.get("availableSeatModelList") || A()
}), js = {
  selectBatchOfSeats: Z,
  updateAvailableSeatModelListSeatGroup: Sn
}, qs = se(
  Ks,
  js
)(Ws), qn = de(
  (o) => {
    var r = o, {
      isSelected: e,
      seatId: n,
      bookingStatus: t,
      color: a
    } = r, i = j(r, [
      "isSelected",
      "seatId",
      "bookingStatus",
      "color"
    ]);
    return /* @__PURE__ */ s(
      re,
      D(N({}, i), {
        bookingStatus: t,
        icon: be(t, !1),
        fill: a,
        isSelected: e,
        seatId: n,
        displayDismissedSeat: !0
      })
    );
  }
);
qn.displayName = "LogicalSeatConfigAdminSeat";
function Qs({
  contractId: e,
  onUpdateContingents: n
}) {
  var c;
  const { t } = E(), a = Te(wa), i = U(), o = O(
    (d) => {
      a && a.find(
        (l) => G(l) === G(d)
      ) || i(Ga(d));
    },
    [a, i]
  ), r = (c = a == null ? void 0 : a.map(G)) != null ? c : A();
  return /* @__PURE__ */ s(
    At.Provider,
    {
      value: q.getDefaultSerializerSdk(),
      children: /* @__PURE__ */ s(
        Ln,
        {
          onSubmitAdminModal: n,
          onChange: o,
          labelClassName: "mpd-btn mpd-btn--primary mpd-color-white",
          className: "stock-contingent-button",
          contractId: e,
          label: t("stock_contingent.add_new_btn"),
          isContingentHidden: (d) => r.includes(G(d))
        }
      )
    }
  );
}
function Hs({ onAction: e }) {
  const { t: n } = E(), t = U();
  function a(i) {
    return K(this, null, function* () {
      yield t(mn(i)), t(Z(V())), e();
    });
  }
  return /* @__PURE__ */ S(H, { children: [
    /* @__PURE__ */ s(
      "button",
      {
        type: "button",
        className: "mpd-btn mpd-btn--primary",
        onClick: () => a(et),
        children: n("seating.dismiss_seat_cta")
      }
    ),
    /* @__PURE__ */ s(
      "button",
      {
        type: "button",
        className: "mpd-btn mpd-btn--secondary",
        onClick: () => a(Ge),
        children: n("seating.restore_seat_cta")
      }
    )
  ] });
}
function Xs() {
  const { t: e } = E();
  return /* @__PURE__ */ S("div", { className: "stock-contingent-content", children: [
    /* @__PURE__ */ s("div", { className: "mpd-seating-sidebar-header", children: /* @__PURE__ */ s("h3", { className: "mpd-seating-sidebar-header__title pt0", children: e("seating.gauge.sidebar.title") }) }),
    /* @__PURE__ */ s("p", { className: "mpd-seating-sidebar-header__help", children: e("seating.gauge.sidebar.message") })
  ] });
}
function Ys(e) {
  function n(t) {
    return /* @__PURE__ */ s(yn, { children: /* @__PURE__ */ s(Vs, { children: /* @__PURE__ */ s(e, N({}, t)) }) });
  }
  return n;
}
function Zs({
  isReady: e,
  logicalSeatConfig: n,
  logicalSeatConfigId: t,
  initLogicalSeatConfigAdmin: a,
  selectBatchOfSeats: i,
  updateAvailableSeatModelListStatus: o,
  contingentList: r
}) {
  const { t: c } = E(), d = U(), {
    selectedContingent: l,
    handleChangePane: u,
    currentPane: p,
    displayDrawButton: g
  } = jn(), { setIsDrawing: m, setSvgDrawerRef: _ } = he();
  B(() => {
    a(t);
  }, [t, a]), B(() => {
    m(!1), i(V());
  }, [p, m, i]);
  const h = O(
    (L, I) => p === P.CONTINGENT && r !== null && l !== null ? Oa(
      L,
      I,
      l
    ) : I,
    [p, r, l]
  ), b = O(() => {
    m(!1);
  }, [m]), C = O(
    (L) => K(null, null, function* () {
      yield o(
        L.status === Ge ? et : Ge
      ), i(V());
    }),
    [i, o]
  ), k = O(
    (L, I, x) => {
      if (x)
        if (p === P.GAUGE)
          i(V([Ut(L)])), C(L);
        else {
          const v = Ut(L);
          d(I ? ft(v) : Qe(v));
        }
    },
    [p, d, i, C]
  );
  if (!e || !n)
    return /* @__PURE__ */ s(ue, {});
  f(
    n.seatConfig,
    "logicalSeatConfig.seatConfig"
  );
  const { seatConfig: y } = n;
  return /* @__PURE__ */ s(
    "div",
    {
      className: "mpd-seating__app context-mpd-seating-stock-contingent-seat-selector",
      id: "mpd-seating__app",
      children: /* @__PURE__ */ S("div", { className: "mpd-seating__app__container", ref: _, children: [
        /* @__PURE__ */ s("div", { className: "mpd-seating__app__event-svg-wrapper", children: /* @__PURE__ */ s(
          ce,
          {
            seatEntityType: "AvailableSeatModel",
            getSelectableSeatIdSet: h,
            seatConfigBlockList: hn(y).seatConfigBlockList,
            isMovingSeat: !1,
            onClickSeat: k,
            SeatElement: qn,
            actionButtons: g && /* @__PURE__ */ s(Ct, {})
          }
        ) }),
        /* @__PURE__ */ s(
          On,
          {
            onChangeTab: u,
            tabs: [
              {
                name: P.CONTINGENT,
                label: c("seating.sidebar_tab.contingent.title"),
                element: /* @__PURE__ */ s(
                  zs,
                  {
                    onUnSelectedContingent: b,
                    onSelectedIdListChange: b
                  }
                ),
                sidebarAction: /* @__PURE__ */ s(
                  Qs,
                  {
                    contractId: n.contract
                  }
                )
              },
              {
                name: P.SEAT_GROUP,
                label: c("seating.sidebar_tab.seat_group.title"),
                element: /* @__PURE__ */ s(
                  qs,
                  {
                    onUnselectSeatGroup: b,
                    onSelectedIdListChange: b
                  }
                ),
                sidebarAction: /* @__PURE__ */ s(
                  Gn,
                  {
                    contractId: n.contract
                  }
                )
              },
              {
                name: P.GAUGE,
                label: c("seating.sidebar_tab.gauge.title"),
                element: /* @__PURE__ */ s(Xs, {}),
                sidebarAction: /* @__PURE__ */ s(Hs, { onAction: b })
              }
            ]
          }
        )
      ] })
    }
  );
}
const Js = Ys(
  Zs
), eo = (e) => ({
  logicalSeatConfig: e.seating.get("logicalSeatConfig"),
  contingentList: e.seating.get("contingentList"),
  isReady: Da(e)
}), to = {
  resetState: me,
  initLogicalSeatConfigAdmin: Ba,
  selectBatchOfSeats: Z,
  updateContingentSeatList: Ma,
  selectBatchOfAvailableSeatModels: Ra,
  updateAvailableSeatModelListContingent: pn,
  updateAvailableSeatModelListStatus: mn,
  removeAvailableSeatModelListContingent: gn,
  updateAvailableSeatModelListSeatGroup: Sn
}, no = se(
  eo,
  to
)(Js);
W({
  foo: "foo"
});
const Qn = W({
  bookingCollection: new mt({
    "hydra:member": []
  }),
  "bookingCollection-fetch-status": W({
    status: null,
    error: null
  }),
  hasMoreBookings: !0,
  currentPage: 0,
  currentSearch: ""
});
function ao(e, n) {
  switch (n.type) {
    case bn:
      return Qn;
    case Fa: {
      const t = e.set(
        "bookingCollection-fetch-status",
        W({
          status: "IN_PROGRESS",
          error: null
        })
      ).set("currentPage", n.page || 0).set("currentSearch", n.search || "");
      if (n.page === 1) {
        const a = new mt({
          "hydra:member": []
        });
        return t.set("hasMoreBookings", !0).set("bookingCollection", a);
      }
      return t;
    }
    case Ua: {
      const { bookingCollection: t, page: a, search: i } = n;
      if ((i || "") !== e.get("currentSearch"))
        return e;
      const o = !!t.getIn(["hydra:view", "hydra:next"]), r = e.setIn(["bookingCollection-fetch-status", "status"], "SUCCEEDED").set("hasMoreBookings", o).set("currentPage", a || 0);
      return a === 1 ? r.set("bookingCollection", t) : r.set(
        "bookingCollection",
        r.get("bookingCollection").merge(t)
      );
    }
    case Va:
      return e.set(
        "bookingCollection",
        e.get("bookingCollection").merge(n.bookingCollection)
      );
    case xa:
      return e.set(
        "bookingCollection-fetch-status",
        W({
          status: null,
          error: null
        })
      ).set(
        "bookingCollection",
        new mt({
          "hydra:member": []
        })
      ).set("currentPage", 0);
    case Ke:
      return e.set(
        "bookingCollection-fetch-status",
        W({
          status: n.status,
          error: n.error
        })
      );
    default:
      return e;
  }
}
const Hn = Ce(void 0);
function io({ children: e }) {
  const [n, t] = Vi(ao, Qn), a = Me(() => ({ state: n, dispatch: t }), [n, t]);
  return /* @__PURE__ */ s(Hn.Provider, { value: a, children: e });
}
function so() {
  const e = _e(Hn);
  if (typeof e == "undefined")
    throw new Error("useBookingList must be used within a BookingListProvider");
  return e;
}
function Xn() {
  const e = U();
  return (n, t) => {
    if (!t.ticket && !t.cartItem)
      throw new Error(
        "Try to focus a seat with a availableSeat but not booking or ticket"
      );
    const a = Ae(t);
    e({ type: Ke, status: "IN_PROGRESS" }), e(Z(V([a])));
    const i = Q(t["@id"]);
    return q.getSdk().getRepository("availableSeat").find(i, ["order", "cart"]).then((o) => {
      if (o.get("order")) {
        const r = o.get("order");
        return Y(r, "availableSeat.order"), q.getSdk().getRepository("order").find(Q(r), Nt).then((c) => {
          const d = It(
            c,
            n
          ), l = new zt({
            "@id": null,
            "@type": "Booking",
            order: d
          });
          e({ type: Ke, status: "SUCCEEDED" }), e(Ft(l));
        });
      }
      if (o.get("cart")) {
        const r = o.get("cart");
        return Y(r, "availableSeat.cart"), q.getSdk().getRepository("cart").find(r, _t).then((c) => {
          const d = vt(c, n), l = new zt({
            "@id": null,
            "@type": "Booking",
            cart: d
          });
          e({ type: Ke, status: "SUCCEEDED" }), e(Ft(l));
        });
      }
      return Promise.resolve();
    });
  };
}
function Ye({
  entity: e,
  participant: n
}) {
  var d;
  if (typeof e.customer == "string")
    throw new rn(
      "entity.customer must be either null or an object"
    );
  const { deskDomain: t } = Ue(), a = n ? n.crmId : (d = e.customer) == null ? void 0 : d.crmId, i = Ve(n || e.customer), o = !!i, r = on(e) ? e.reservationName : null;
  let c = null;
  return o ? c = /* @__PURE__ */ s("h3", { className: "mpd-seating-booking-tile__customer", children: a ? /* @__PURE__ */ s(
    "a",
    {
      className: "mpd-seating-booking-tile__customer--clickable mpd-color-black",
      href: `${t}/customers/${Q(a)}`,
      children: i
    }
  ) : (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    /* @__PURE__ */ s(H, { children: i })
  ) }) : r && (c = r), c ? /* @__PURE__ */ s(H, { children: c }) : null;
}
function oo(e, n) {
  return e.entityName ? e.entityName === Le.CART && n("booking.number.booking", {
    cart: e.entityId
  }) || e.entityName === Le.ORDER && n("booking.number.order", {
    order: e.entityId
  }) || null : e.cart ? (f(e.cart, "booking.cart"), n("booking.number.booking", {
    cart: e.cart.getShortId()
  })) : e.order ? (f(e.order, "booking.order"), n("booking.number.order", {
    order: e.order.getShortId()
  })) : null;
}
function ro(e, n, t, a) {
  var o, r, c, d, l, u, p, g;
  if (!t)
    return {
      seatLabel: null,
      price: null,
      participant: null
    };
  if (!e.bookingItemList.size) {
    const m = e.order || e.cart, _ = (o = (n || A()).find((k) => (f(k.seat, "availableSeat.seat"), t === k.seat["@id"]))) == null ? void 0 : o.ticket;
    f(m, "typeBooking"), z(
      m.ticketList,
      "typeBooking.ticketList"
    );
    const h = m.ticketList.find(
      (k) => _ === k["@id"]
    );
    let b = null;
    if (h && h.participant) {
      f(h, "ticket"), F(h.participant, "ticket.participant");
      const k = (r = h.participant) == null ? void 0 : r.get("firstname"), y = (c = h.participant) == null ? void 0 : c.get("lastname");
      b = k || y ? {
        crmId: (d = h.participant) == null ? void 0 : d.get("crmId"),
        firstname: k,
        lastname: y
      } : null;
    }
    const C = h && `${h == null ? void 0 : h.ticketPriceName} ${oe(
      (l = h == null ? void 0 : h.facialValue) != null ? l : 0,
      (u = h == null ? void 0 : h.currency) != null ? u : ""
    )}`;
    return {
      seatLabel: a,
      price: C,
      participant: b
    };
  }
  const i = e.bookingItemList.find(
    (m) => `${m.seatId}` === Q(t)
  );
  return {
    seatLabel: i == null ? void 0 : i.seatLabel,
    price: `${i == null ? void 0 : i.ticketPriceName} ${oe(
      (p = i == null ? void 0 : i.ticketPriceFacialValue) != null ? p : 0,
      (g = i == null ? void 0 : i.currency) != null ? g : ""
    )}`,
    participant: i == null ? void 0 : i.participant
  };
}
function Yn({
  booking: e
}) {
  const { t: n } = E(), t = nn(), { seatInfoId: a, seatLabel: i } = $a(t.getState()), o = bt(), r = ro(
    e,
    o,
    a,
    i
  );
  return /* @__PURE__ */ S("div", { className: "booking-item-recap", children: [
    /* @__PURE__ */ s("div", { children: r.seatLabel ? /* @__PURE__ */ S(H, { children: [
      /* @__PURE__ */ s("span", { className: "booking-item-recap__seat", children: r.seatLabel }),
      r.price && ` : ${r.price}`
    ] }) : oo(e, n) }),
    e.cart && typeof e.cart != "string" && /* @__PURE__ */ s(
      Ye,
      {
        entity: e.cart,
        participant: r.participant
      }
    ),
    e.order && typeof e.order != "string" && /* @__PURE__ */ s(
      Ye,
      {
        entity: e.order,
        participant: r.participant
      }
    )
  ] });
}
function co({
  booking: e,
  onClick: n,
  focusBookingOnSeatPlan: t,
  unFocusBookingOnSeatPlan: a
}) {
  const i = (o) => {
    o == null || o.stopPropagation(), o == null || o.preventDefault(), n(e);
  };
  return B(() => () => a(e), [e, a]), /* @__PURE__ */ s(
    "div",
    {
      className: "booking-line booking-line--clickable",
      "aria-hidden": "true",
      onClick: i,
      onMouseEnter: () => {
        t(e);
      },
      onMouseLeave: () => {
        a(e);
      },
      children: /* @__PURE__ */ s(Yn, { booking: e })
    }
  );
}
function lo({ cart: e, eventDateId: n, canMoveSeats: t }) {
  var l;
  const { t: a } = E(), { deskDomain: i } = Ue();
  M(e.retailValue, "cart.retailValue"), M(e.currency, "cart.currency");
  const o = oe(e.retailValue, e.currency);
  f(e, "cart");
  const r = e.get("@id");
  if (!r)
    throw new Error("Unable to get id for cart. This should not happen.");
  const { sellingDevice: c, hasMovableSeats: d } = e;
  return f(c, "sellingDevice"), /* @__PURE__ */ S(H, { children: [
    /* @__PURE__ */ S("div", { className: "mpd-seating-booking-tile__container", children: [
      a("booking.number.booking", { cart: e.getShortId() }),
      /* @__PURE__ */ s(Ye, { entity: e }),
      /* @__PURE__ */ s("h2", { className: "mpd-seating-booking-tile__price", children: o }),
      /* @__PURE__ */ s("div", { children: e.nbTickets !== 0 && a("order.nb_tickets", {
        count: (l = e.nbTickets) != null ? l : 0
      }) }),
      e.comment !== null && /* @__PURE__ */ S("div", { className: "mpd-seating-booking-tile__comment", children: [
        a("order.comment"),
        " ",
        e.comment
      ] })
    ] }),
    /* @__PURE__ */ s("div", { className: "mpd-seating-booking-tile__action-cell", children: /* @__PURE__ */ S("div", { children: [
      t && d && /* @__PURE__ */ s(
        "a",
        {
          href: `${i}/carts/${Q(
            r
          )}/move-seats/${Q(n)}`,
          className: "mpd-btn mpd-btn--secondary block",
          children: a("booking.move_seats")
        }
      ),
      /* @__PURE__ */ s(
        "a",
        {
          href: `${i}/carts/${Q(r)}/reservation`,
          className: "mpd-btn mpd-btn--primary block",
          children: a("booking.see_detail_action")
        }
      )
    ] }) })
  ] });
}
function uo({ order: e, eventDateId: n, canMoveSeats: t }) {
  var l;
  const { t: a } = E(), { deskDomain: i } = Ue();
  f(e, "order"), M(e.retailValue, "order.retailValue"), M(e.currency, "order.currency");
  const o = oe(e.retailValue, e.currency), r = e.get("@id");
  if (!r)
    throw new Error("Unable to get id for order. This should not happen.");
  const { sellingDevice: c, hasMovableSeats: d } = e;
  return f(c, "sellingDevice"), /* @__PURE__ */ S(H, { children: [
    /* @__PURE__ */ S("section", { className: "mpd-seating-booking-tile__container", children: [
      /* @__PURE__ */ S("div", { children: [
        /* @__PURE__ */ s("span", { children: a("booking.number.order", { order: e.getShortId() }) }),
        /* @__PURE__ */ s(Ye, { entity: e })
      ] }),
      o !== null && /* @__PURE__ */ s("h2", { className: "mpd-seating-booking-tile__price", children: o }),
      /* @__PURE__ */ s("div", { children: e.nbTickets !== 0 && a("order.nb_tickets", {
        count: (l = e.nbTickets) != null ? l : 0
      }) }),
      e.comment !== null && /* @__PURE__ */ S("div", { className: "mpd-seating-booking-tile__comment", children: [
        a("order.comment"),
        " ",
        e.comment
      ] })
    ] }),
    typeof e != "string" && /* @__PURE__ */ s("div", { className: "mpd-seating-booking-tile__action-cell", children: /* @__PURE__ */ S("div", { children: [
      t && !!d && /* @__PURE__ */ s(
        "a",
        {
          href: `${i}/orders/${Q(
            r
          )}/move-seats/${Q(n)}`,
          className: "mpd-btn mpd-btn--secondary block",
          children: a("booking.move_seats")
        }
      ),
      /* @__PURE__ */ s(
        "a",
        {
          href: `${i}/orders/${Q(r)}`,
          className: "mpd-btn mpd-btn--primary block",
          children: a("booking.see_detail_action")
        }
      )
    ] }) })
  ] });
}
function go({ booking: e, eventDateId: n, canMoveSeats: t }) {
  const a = e.entityName || !!e.cart && Le.CART || !!e.order && Le.ORDER || null;
  return F(e.cart, "booking.cart"), F(e.order, "booking.order"), /* @__PURE__ */ S("div", { className: "booking-collection__detail", children: [
    /* @__PURE__ */ s("div", { className: "booking-collection__detail__header", children: /* @__PURE__ */ s(Yn, { booking: e }) }),
    a === Le.CART && e.cart && /* @__PURE__ */ s(
      lo,
      {
        canMoveSeats: t,
        cart: e.cart,
        eventDateId: n
      }
    ),
    a === Le.ORDER && e.order && /* @__PURE__ */ s(
      uo,
      {
        canMoveSeats: t,
        order: e.order,
        eventDateId: n
      }
    )
  ] });
}
function po({
  eventDateId: e,
  contractId: n,
  focusBookingOnSeatPlan: t,
  unFocusBookingOnSeatPlan: a,
  searchFilter: i,
  canMoveSeats: o
}) {
  const { t: r } = E(), c = U(), d = fn(), l = bt(), u = Xn(), p = i.length > 0, { state: g, dispatch: m } = so(), _ = g.get("bookingCollection"), h = g.get("currentPage"), b = g.getIn(["bookingCollection-fetch-status", "status"]) === "IN_PROGRESS", C = g.get("bookingCollection-fetch-status").get("error"), k = g.getIn(["bookingCollection-fetch-status", "status"]) === "SUCCEEDED", y = g.get("hasMoreBookings"), L = _.getMembers(), I = (T) => {
    z(
      T.bookingItemList,
      "booking.bookingItemList"
    );
    const w = T.bookingItemList.find(
      (ee) => ee.seatId !== null
    );
    if (!w || !l)
      return;
    const R = `/v1/seats/${w.seatId}`, X = l.find((ee) => (f(ee.seat, "avs.seat"), ee.seat["@id"] === R));
    X && u(e, X);
  }, x = O(
    (T = !0) => {
      za({
        dispatch: m,
        eventDateId: e,
        contractId: n,
        currentPage: h,
        getFirstPage: T,
        search: i,
        itemsPerPage: 50
      });
    },
    [m, e, n, h, i]
  );
  B(() => {
    if (!p)
      return;
    const T = setTimeout(x, 300);
    return () => clearTimeout(T);
  }, [p, x]), B(() => {
    c(Cn()), c(Wa());
  }, [c, i]);
  const v = !i && !b;
  return d ? /* @__PURE__ */ s(
    go,
    {
      booking: d,
      eventDateId: e,
      canMoveSeats: o
    }
  ) : /* @__PURE__ */ S("div", { className: "booking-collection", children: [
    v && /* @__PURE__ */ s("div", { className: "booking-collection__description", children: r("booking.description") }),
    b && /* @__PURE__ */ s("div", { className: "pt5", children: /* @__PURE__ */ s(tt, {}) }),
    C && /* @__PURE__ */ s("div", { className: "mpd-alert mpd-alert--error", children: C }),
    !!L.size && !b && /* @__PURE__ */ S("div", { className: "booking-collection__list", children: [
      /* @__PURE__ */ s("h3", { className: "booking-collection__list__title", children: r("order_management.select_order") }),
      L.map((T) => /* @__PURE__ */ s(
        co,
        {
          booking: T,
          onClick: I,
          focusBookingOnSeatPlan: t,
          unFocusBookingOnSeatPlan: a
        },
        T.get("@id")
      )),
      y && /* @__PURE__ */ s("div", { className: "txtcenter", children: /* @__PURE__ */ s(
        "button",
        {
          type: "button",
          className: `mpd-btn mpd-btn--link ${b ? "mpd-btn--loading" : ""}`,
          onClick: () => x(!1),
          children: r("common.see_more")
        }
      ) })
    ] }),
    k && L.size === 0 && /* @__PURE__ */ s("div", { className: "pt5", children: r("no_result") })
  ] });
}
function So(e) {
  return f(e, "booking"), z(
    e.bookingItemList,
    "booking.bookingItemList"
  ), e.bookingItemList.map(
    (n) => `${n.seatId}`
  );
}
function mo({
  eventDateId: e,
  contractId: n,
  canMoveSeats: t
}) {
  const [a, i] = $(""), o = U(), { t: r } = E(), c = (l) => {
    i(l.target.value);
  }, d = (l, u = !0) => {
    window.requestAnimationFrame(() => {
      const p = "mpd-seating__seat--is-focused", g = document.getElementsByClassName(p);
      for (; g.length > 0; )
        g[0].classList.remove(p);
      u && So(l).map(
        (h) => document.getElementById(h)
      ).forEach((h) => {
        h && h.classList.add(p);
      });
    });
  };
  return /* @__PURE__ */ S(pe, { children: [
    /* @__PURE__ */ s(
      "form",
      {
        onSubmit: (l) => {
          l.preventDefault(), o(Cn());
        },
        children: /* @__PURE__ */ S("div", { className: "form-group p0", children: [
          /* @__PURE__ */ s(
            "input",
            {
              className: "form-control form-control--with-icon booking-search",
              type: "search",
              onChange: c,
              value: a,
              placeholder: r("order_management.sidebar.search.placeholder")
            }
          ),
          /* @__PURE__ */ s(
            Se,
            {
              className: "form-control-icon",
              icon: "magnifying-glass",
              height: "18",
              width: "18"
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ s(
      po,
      {
        searchFilter: a,
        canMoveSeats: t,
        eventDateId: e,
        contractId: n,
        focusBookingOnSeatPlan: (l) => d(l, !0),
        unFocusBookingOnSeatPlan: (l) => d(l, !1)
      }
    )
  ] });
}
const Zn = de(
  (c) => {
    var d = c, {
      seatEntity: e,
      seatId: n,
      color: t,
      isSelectable: a,
      isSelected: i,
      bookingStatus: o
    } = d, r = j(d, [
      "seatEntity",
      "seatId",
      "color",
      "isSelectable",
      "isSelected",
      "bookingStatus"
    ]);
    const l = fn(), u = !(l != null && l.bookingItemList.size), p = u ? Ka(l).map(G) : l == null ? void 0 : l.bookingItemList.map(
      (m) => `${m.seatId}`
    ), g = u ? e["@id"] : `${n}`;
    return /* @__PURE__ */ s(
      re,
      D(N({}, r), {
        seatEntity: e,
        seatId: n,
        isSelectable: a,
        bookingStatus: o,
        displayDismissedSeat: !0,
        icon: be(o, !1),
        fill: t,
        isSelected: l ? p.contains(g) : i,
        isZoomed: i
      })
    );
  }
);
Zn.displayName = "OrderManagementSeat";
function ho({
  isReady: e,
  displayEventDateInfo: n = !0,
  eventDateId: t,
  canMoveSeats: a = !0
}) {
  const i = Ui(null), o = U(), r = Xn(), c = Te(an), d = O(() => {
    o(ja(t));
  }, [o, t]);
  B(() => {
    if (!t)
      throw new Error("No eventDateId provided");
    d();
  }, [t, d]);
  const l = O(
    (g, m, _) => {
      _ && r(
        qe("/v1/event_dates/", t),
        g
      );
    },
    [t, r]
  );
  if (!e)
    return /* @__PURE__ */ s(ue, {});
  if (!c)
    throw new Error(
      "SeatConfig should be set in store. Maybe you forgot to check that `app.loadStatus.seatConfigData` is set"
    );
  M(c.contract, "seatConfig.contract");
  const u = G(c.contract), p = qe("/v1/event_dates/", t);
  return /* @__PURE__ */ s(
    "div",
    {
      className: "mpd-seating__app context-order-management",
      id: "mpd-seating__app",
      children: /* @__PURE__ */ s("div", { className: "mpd-seating__app__container", ref: i, children: /* @__PURE__ */ S(io, { children: [
        /* @__PURE__ */ S("div", { className: "mpd-seating__app__event-svg-wrapper", children: [
          n && /* @__PURE__ */ s(at, {}),
          /* @__PURE__ */ s(
            ce,
            {
              SeatElement: Zn,
              seatEntityType: "AvailableSeat",
              getSelectableSeatIdSet: qa,
              onClickSeat: l,
              seatConfigBlockList: c.seatConfigBlockList || [],
              isMovingSeat: !1,
              isPdfDownloadAvailable: !0
            }
          )
        ] }),
        /* @__PURE__ */ s(
          mo,
          {
            contractId: u,
            eventDateId: p,
            canMoveSeats: a
          }
        )
      ] }) })
    }
  );
}
const bo = de(ho), fo = (e) => ({
  isReady: _n(e) && fe(e)
}), Co = se(
  fo
)(bo), Jn = Ce(null);
function _o() {
  return _e(Jn);
}
function vo({
  order: e,
  children: n
}) {
  return /* @__PURE__ */ s(Jn.Provider, { value: e, children: n });
}
function ko({ order: e }) {
  var a, i, o, r;
  const { t: n } = E();
  f(e, "order");
  const t = oe(
    (a = e.retailValue) != null ? a : 0,
    (i = e.currency) != null ? i : ""
  );
  return /* @__PURE__ */ s("section", { className: "mpd-seating-booking-tile__container", children: /* @__PURE__ */ S("div", { children: [
    /* @__PURE__ */ S("div", { className: "txtcenter", children: [
      /* @__PURE__ */ s("span", { children: n("sales.list_header.order", { number: e.getShortId() }) }),
      /* @__PURE__ */ s(Fn, { entity: e })
    ] }),
    /* @__PURE__ */ S("div", { className: "mpd-seating-booking-tile__ticket_coupon_details txtcenter mt4", children: [
      t !== null && /* @__PURE__ */ s("header", { className: "mpd-table__cell-header", children: t }),
      /* @__PURE__ */ s("article", { className: "mpd-table__cell-description txtcenter mt4", children: e.nbTickets !== 0 && n("order.nb_tickets", {
        count: (o = e.nbTickets) != null ? o : 0
      }) })
    ] }),
    e.comment != null && /* @__PURE__ */ S("div", { className: "mpd-seating-booking-tile__comment", children: [
      n("order.comment"),
      " ",
      e.comment
    ] }),
    /* @__PURE__ */ S("div", { className: "mpd-seating-booking-tile__origin", children: [
      n("sales.list_header.origin"),
      " ",
      n("order.origin", { name: (r = e == null ? void 0 : e.originType) == null ? void 0 : r.toLowerCase() })
    ] })
  ] }) });
}
function Lo({
  seatConfig: e,
  selectedSeatIdSet: n,
  order: t
}) {
  return /* @__PURE__ */ s("div", { className: "mpd-seating__order-sidebar", children: /* @__PURE__ */ S("div", { className: "replacement-sidebar__content", children: [
    /* @__PURE__ */ s("div", { className: "replacement-sidebar__name", children: e.label }),
    /* @__PURE__ */ s("hr", {}),
    /* @__PURE__ */ s("div", { children: /* @__PURE__ */ s(
      Un,
      {
        cartOrOrder: t,
        selectedSeatIdSet: n,
        nbSeatsInBooking: Je(t).size
      }
    ) }),
    /* @__PURE__ */ s("table", { className: "mpd-table mpd-table--narrow mt0", children: /* @__PURE__ */ s("tbody", { children: /* @__PURE__ */ s(ko, { order: t }) }) })
  ] }) });
}
const ea = de(
  (r) => {
    var c = r, {
      color: e,
      isSelectable: n,
      isSelected: t,
      bookingStatus: a,
      seatEntity: i
    } = c, o = j(c, [
      "color",
      "isSelectable",
      "isSelected",
      "bookingStatus",
      "seatEntity"
    ]);
    const d = _o(), l = !!(d && Je(d).find((u) => u["@id"] === i["@id"]));
    return /* @__PURE__ */ s(
      re,
      D(N({}, o), {
        seatEntity: i,
        isSelectable: n,
        bookingStatus: a,
        icon: be(a, l),
        fill: e,
        isSelected: t || l,
        isZoomed: t
      })
    );
  }
);
ea.displayName = "OrderReplacementSeat";
function No(e, n) {
  return K(this, null, function* () {
    return q.getSdk().getRepository("order").find(e, {
      fields: Nt
    }).then((a) => It(
      a,
      `/v1/event_dates/${n}`
    ));
  });
}
function Io(e, n, t) {
  const [a, i] = $(null), o = U();
  B(() => {
    No(e, n).then((c) => {
      const d = Je(c);
      o(
        He(
          // @ts-expect-error AvailableSeatType and AvailableSeat are the same
          t && (t == null ? void 0 : t.size) > 0 ? t : d
        )
      ), i(c);
    });
  }, [e, o, n, t]);
  const r = O(
    (c, d) => {
      if (!a)
        return;
      const l = a.update("ticketList", (u) => (z(u, "ticketList"), u.map((p) => p.update("availableSeat", (g) => (F(g, "ticket.availableSeat"), g && g["@id"] === c["@id"] ? d : g)))));
      i(l);
    },
    [a]
  );
  return [a, r];
}
var dt, Ie;
let To = (dt = class extends Be {
  constructor(t) {
    super(t);
    // eslint-disable-next-line react/sort-comp
    ot(this, Ie);
    this.state = {
      isReplacementWarningModalOpened: !1,
      newCategory: null,
      oldCategory: null,
      oldContingent: null,
      newContingent: null,
      selectedSeat: null
    }, this.init = this.init.bind(this), this.setRef = this.setRef.bind(this), this.selectOrMoveSeat = this.selectOrMoveSeat.bind(this), this.toggleSelectAllSeat = this.toggleSelectAllSeat.bind(this), rt(this, Ie, new cn({
      // eslint-disable-next-line react/destructuring-assignment
      selectBatchOfSeats: this.props.selectBatchOfSeats
    }));
  }
  componentDidMount() {
    const { orderId: t } = this.props;
    if (!t)
      throw new Error("OrderId is required context");
    this.init();
  }
  componentDidUpdate(t) {
    var i;
    const { selectedSeatIdSet: a } = this.props;
    (i = t.selectedSeatIdSet) != null && i.equals(a) || Pe(this, Ie).handleSelectedSeatIdListChange(
      a != null ? a : V()
    );
  }
  componentWillUnmount() {
    const { resetState: t } = this.props;
    t();
  }
  setRef(t) {
    t && Pe(this, Ie).init();
  }
  init() {
    const { eventDateId: t, orderId: a, initOrderReplacement: i } = this.props;
    i(a, t);
  }
  selectOrMoveSeat(t, a, i) {
    var h, b;
    const {
      selectedSeatIdSet: o,
      selectOrMoveSeat: r,
      order: c,
      replaceAvailableSeat: d,
      toast: l,
      t: u
    } = this.props, { isReplacementWarningModalOpened: p } = this.state, g = o == null ? void 0 : o.first();
    if (!c || !i)
      return;
    const m = [
      ne.IN_ORDER,
      ne.IN_EXTERNAL_PROVIDER_ORDER
    ].includes(t.bookingStatus);
    if (!(!m && Qa(
      t,
      c,
      g
    )) || p || !g) {
      const C = Ae(t);
      r(
        c,
        C,
        i,
        m,
        null,
        d,
        this.init,
        l,
        u
      ), this.setState({
        isReplacementWarningModalOpened: !1,
        oldCategory: null,
        newCategory: null,
        oldContingent: null,
        newContingent: null
      });
    } else {
      const C = Ha(c, g);
      M(C, "availableSeat"), f(
        C.seatGroup,
        "availableSeat.seatGroup"
      ), f(t.seatGroup, "seatEntity.seatGroup"), F(
        C.stockContingent,
        "availableSeat.stockContingent"
      ), F(
        t.stockContingent,
        "seatEntity.stockContingent"
      );
      const k = C.stockContingent, y = t.stockContingent, L = k && typeof k == "object" ? k.contingent : null, I = y && typeof y == "object" ? y.contingent : null;
      F(L, "stockContingent.contingent"), F(I, "stockContingent.contingent");
      const x = L && typeof L == "object" && (h = L.name) != null ? h : u("seating.contingent.no-contingent"), v = I && typeof I == "object" && (b = I.name) != null ? b : u("seating.contingent.no-contingent");
      this.setState({
        oldCategory: C.seatGroup.label,
        newCategory: t.seatGroup.label,
        oldContingent: x,
        newContingent: v
      }), this.setState({
        selectedSeat: t,
        isReplacementWarningModalOpened: !0
      });
    }
  }
  toggleSelectAllSeat() {
    const { selectedSeatIdSet: t, order: a, dispatch: i } = this.props;
    M(a);
    const o = $t(a);
    if (t && t.size === o.size)
      i(Z(V()));
    else {
      const c = o.map((d) => {
        const l = d.get("seat");
        return f(l), Number(l.getShortId());
      }).toSet();
      i(Z(c));
    }
  }
  render() {
    const {
      selectedSeatIdSet: t,
      isReady: a,
      getSelectableSeatIdSet: i,
      seatConfig: o,
      onDismissSeating: r,
      order: c,
      t: d,
      onConfirmAction: l,
      externalActions: u
    } = this.props, {
      isReplacementWarningModalOpened: p,
      oldCategory: g,
      newCategory: m,
      oldContingent: _,
      newContingent: h,
      selectedSeat: b
    } = this.state;
    if (!a)
      return /* @__PURE__ */ s(ue, {});
    if (!o)
      throw new Error("Unable to find seatConfig. This should not happen.");
    return /* @__PURE__ */ s("div", { className: "mpd-seating__app context-order", id: "mpd-seating__app", children: /* @__PURE__ */ S("div", { className: "mpd-seating__app__container", ref: this.setRef, children: [
      /* @__PURE__ */ S("div", { className: "mpd-seating__app__event-svg-wrapper", children: [
        /* @__PURE__ */ s(at, {}),
        /* @__PURE__ */ s(
          ce,
          {
            seatEntityType: "AvailableSeat",
            SeatElement: ea,
            getSelectableSeatIdSet: (C, k) => c ? i(C, k, c) : V(),
            onClickSeat: this.selectOrMoveSeat,
            seatConfigBlockList: o ? o.seatConfigBlockList : [],
            isMovingSeat: !!(t && t.size > 0),
            externalActions: u
          }
        )
      ] }),
      /* @__PURE__ */ s(
        pe,
        {
          onClose: r,
          action: /* @__PURE__ */ S(H, { children: [
            /* @__PURE__ */ s(
              "button",
              {
                type: "button",
                className: "mpd-btn",
                onClick: this.toggleSelectAllSeat,
                children: c && t && t.size === $t(c).size ? d("cart_replacement.deselect_all") : d("cart_replacement.select_all")
              }
            ),
            l && /* @__PURE__ */ s(
              "button",
              {
                type: "button",
                className: "mpd-btn mpd-btn--primary",
                onClick: l,
                children: d("cart_replacement.confirm")
              }
            )
          ] }),
          children: c && /* @__PURE__ */ s(
            Lo,
            {
              seatConfig: o,
              selectedSeatIdSet: t,
              order: c
            }
          )
        }
      ),
      p && /* @__PURE__ */ s(
        $n,
        {
          oldCategory: g,
          newCategory: m,
          oldContingent: _,
          newContingent: h,
          onCancel: () => this.setState({
            isReplacementWarningModalOpened: !1,
            oldCategory: null,
            newCategory: null,
            oldContingent: null,
            newContingent: null
          }),
          onConfirm: () => {
            b && this.selectOrMoveSeat(b, !0, !0);
          }
        }
      )
    ] }) });
  }
}, Ie = new WeakMap(), st(dt, "defaultProps", {
  onDismissSeating: null,
  onConfirmAction: null
}), dt);
function Ao(e) {
  const { orderId: n, eventDateId: t, defaultSelectedSeatIdList: a } = e, i = te(), { t: o } = E(), [r, c] = Io(
    n,
    t,
    a
  ), d = U();
  return /* @__PURE__ */ s(vo, { order: r, children: /* @__PURE__ */ s(
    To,
    D(N({}, e), {
      order: r,
      replaceAvailableSeat: c,
      toast: i,
      t: o,
      dispatch: d
    })
  ) });
}
const Eo = (e) => ({
  seatConfig: e.seating.get("seatConfig"),
  isReady: fe(e),
  getSelectableSeatIdSet: Lt,
  selectedSeatIdSet: e.seating.get("selectedSeatIdSet")
}), yo = {
  resetState: me,
  initOrderReplacement: vn,
  selectBatchOfSeats: Z,
  selectOrMoveSeat: kt
}, Po = se(
  Eo,
  yo
)(Ao), ta = de(
  (c) => {
    var d = c, {
      color: e,
      seatEntity: n,
      isSelectable: t,
      isSelected: a,
      bookingStatus: i,
      isDesk: o
    } = d, r = j(d, [
      "color",
      "seatEntity",
      "isSelectable",
      "isSelected",
      "bookingStatus",
      "isDesk"
    ]);
    const l = xn(), u = !!(l && Ee(l).find((p) => p["@id"] === n["@id"]));
    return /* @__PURE__ */ s(
      re,
      D(N({}, r), {
        isDesk: o,
        bookingStatus: i,
        seatEntity: n,
        icon: be(i, u),
        fill: !t && !o ? Re : e,
        isSelectable: t,
        isSelected: a || u,
        isZoomed: a
      })
    );
  }
);
ta.displayName = "OrderViewerSeat";
function wo({
  nbSelectedSeat: e,
  nbSeatsInBooking: n
}) {
  const { t } = E();
  return /* @__PURE__ */ s("div", { className: "mpd-seating__viewer-sidebar", children: /* @__PURE__ */ s("div", { className: "mpd-seating__viewer-sidebar__top", children: /* @__PURE__ */ S("div", { className: "mpd-seating__viewer-sidebar__instruction", children: [
    /* @__PURE__ */ S("div", { className: "mb3", children: [
      /* @__PURE__ */ s("div", { className: "larger", children: t("seating.move_seat.selected_seats", {
        count: e
      }) }),
      /* @__PURE__ */ s("div", { className: "smaller", children: t("seating.move_seats.nb_seats_in_order", {
        count: n
      }) })
    ] }),
    e > 0 && /* @__PURE__ */ s("p", { className: "small mt0", children: t("seating.help_move_seats", { count: e }) })
  ] }) }) });
}
let Go = class extends Be {
  constructor(n) {
    super(n), this.init = this.init.bind(this), this.selectOrMoveSeat = this.selectOrMoveSeat.bind(this);
  }
  componentDidMount() {
    const { cartId: n } = this.props;
    if (!n)
      throw new Error("CartId is required");
    this.init();
  }
  componentWillUnmount() {
    const { resetState: n } = this.props;
    n();
  }
  init() {
    const { eventDateId: n, cartId: t, initOrderViewer: a } = this.props;
    a(t, n);
  }
  selectOrMoveSeat(n, t, a) {
    const { cart: i, selectOrMoveSeat: o, replaceAvailableSeat: r, toast: c, t: d } = this.props;
    if (!i)
      return;
    const l = Ae(n), u = ln(n);
    o(
      i,
      l,
      a,
      u,
      i,
      r,
      this.init,
      c,
      d
    );
  }
  render() {
    var r;
    const {
      isReady: n,
      getSelectableSeatIdSet: t,
      seatConfig: a,
      selectedSeatIdSet: i,
      cart: o
    } = this.props;
    return n ? a ? /* @__PURE__ */ s("div", { className: "mpd-seating__app context-viewer", id: "mpd-seating__app", children: /* @__PURE__ */ S("div", { className: "mpd-seating__app__container", children: [
      /* @__PURE__ */ S("div", { className: "mpd-seating__app__event-svg-wrapper", children: [
        /* @__PURE__ */ s(at, {}),
        /* @__PURE__ */ s(
          ce,
          {
            seatEntityType: "AvailableSeat",
            SeatElement: ta,
            getSelectableSeatIdSet: (c, d) => o ? t(c, d, o) : V(),
            onClickSeat: this.selectOrMoveSeat,
            isMovingSeat: !!(i && i.size > 0),
            seatConfigBlockList: a ? a.seatConfigBlockList : []
          }
        )
      ] }),
      /* @__PURE__ */ s(pe, { children: o && /* @__PURE__ */ s(
        wo,
        {
          nbSelectedSeat: (r = i && i.size) != null ? r : 0,
          nbSeatsInBooking: Ee(o).size
        }
      ) })
    ] }) }) : null : /* @__PURE__ */ s(ue, {});
  }
};
function Oo(e) {
  const { cartId: n, eventDateId: t } = e, a = te(), { t: i } = E(), [o, r] = Wn(n, t);
  return /* @__PURE__ */ s(Vn, { cart: o, children: /* @__PURE__ */ s(
    Go,
    D(N({}, e), {
      cart: o,
      replaceAvailableSeat: r,
      toast: a,
      t: i
    })
  ) });
}
const Do = (e) => ({
  seatConfig: e.seating.get("seatConfig"),
  isReady: fe(e),
  getSelectableSeatIdSet: Ya,
  selectedSeatIdSet: e.seating.get("selectedSeatIdSet")
}), Ro = {
  resetState: me,
  selectOrMoveSeat: kt,
  initOrderViewer: Xa
}, Mo = se(
  Do,
  Ro
)(Oo);
function na(e, n) {
  f(e.ticketPrice, "cartItem.ticketPrice");
  const { eventDate: t } = e.ticketPrice;
  return f(t, "cartItem.ticketPrice.eventDate"), t.getShortId() === n.toString();
}
function Bo() {
  const e = es(), n = ts();
  return Me(() => {
    if (e)
      return {
        message: e,
        "mapado:error": n
      };
  }, [e, n]);
}
function xo() {
  const [e, n] = $(0), t = Bo();
  return B(() => {
    t && (n((i) => i + 1), setTimeout(() => {
      n((i) => i + 1);
    }, 100));
  }, [t]), e % 2 !== 1;
}
const aa = Ce(
  void 0
);
function Vo({
  value: e,
  children: n
}) {
  return /* @__PURE__ */ s(aa.Provider, { value: e, children: n });
}
function Uo() {
  const e = _e(aa);
  if (typeof e == "undefined")
    throw new Error(
      "useCurrentContingentContext must be used within a CurrentContingentContextProvider. Did you pass a currentContingentId to the SeatingPlanPurchaseSeat?"
    );
  return e;
}
function ia(d) {
  var l = d, {
    color: e,
    isSelectable: n,
    isSelected: t,
    bookingStatus: a,
    seatEntity: i,
    getTicketPriceListBySeatGroup: o,
    isDesk: r
  } = l, c = j(l, [
    "color",
    "isSelectable",
    "isSelected",
    "bookingStatus",
    "seatEntity",
    "getTicketPriceListBySeatGroup",
    "isDesk"
  ]);
  const u = i == null ? void 0 : i.seatGroup;
  f(u, "seatGroup");
  const p = o(
    u["@id"],
    G(i.stockContingent)
  ), g = Uo();
  Hi(g, "currentContingentId");
  const m = Tt(
    i,
    p,
    g,
    n
  ), _ = () => i.stockContingent && typeof i.stockContingent == "object" && i.stockContingent.isExportedOnProvider ? "external-provider-filled" : t ? "seat-filled" : be(a, !1);
  return /* @__PURE__ */ s(
    re,
    D(N({}, c), {
      isDesk: r,
      seatEntity: i,
      isSelectable: m,
      bookingStatus: a,
      icon: _(),
      fill: !m && !r ? Re : e,
      isSelected: t
    })
  );
}
ia.displayName = "SeatingPlanPurchaseSeat";
function Fo({
  cart: e,
  getTicketPriceListBySeatGroupAndStockContingent: n,
  handleChangeTicketPrice: t,
  sidebarPrevAction: a,
  sidebarNextAction: i,
  eventDateId: o,
  locale: r
}) {
  const { t: c } = E(), { selectedView: d } = De(), { currentDomain: l } = Ue(), [u, p] = $(!1), g = Te(Za), m = Te(Ja);
  if (!e)
    return null;
  z(e.cartItemList, "cart.cartItemList");
  const _ = e.cartItemList.filter(
    (C) => na(C, o)
  );
  if (!_.size)
    return null;
  const h = nt("plan-purchase-sidebar", {
    "plan-purchase-sidebar--force-visible": u
  }), b = (C, k) => {
    if (!C)
      return;
    const { ticketPrice: y } = k;
    z(
      e.cartItemWithOfferList,
      "cart.cartItemWithOfferList"
    );
    const L = e.cartItemWithOfferList.find((v) => (f(v.cartItem, "cartItemWithOffer.cartItem"), G(v.cartItem) === G(k)));
    f(L, "cartItemWithOffer");
    const { availableSeatList: I } = L;
    z(
      I,
      "cartItemWithOffer.availableSeatList"
    );
    const x = I.first();
    f(x, "availableSeatList.first()"), f(y, "cartItem.ticketPrice"), t(
      x,
      y,
      C
    );
  };
  return /* @__PURE__ */ S(H, { children: [
    !u && /* @__PURE__ */ S("div", { className: "plan-purchase-responsive-bar", children: [
      a,
      /* @__PURE__ */ s(
        "button",
        {
          type: "button",
          className: "mpd-btn mpd-btn--primary",
          onClick: () => p(!0),
          children: c("next")
        }
      )
    ] }),
    /* @__PURE__ */ s(
      pe,
      {
        className: h,
        action: (a || i) && /* @__PURE__ */ S(H, { children: [
          u ? /* @__PURE__ */ s(
            "button",
            {
              type: "button",
              className: "mpd-btn",
              onClick: () => p(!1),
              children: c("seating.plan_purchase.back_plan")
            }
          ) : a,
          i
        ] }),
        children: /* @__PURE__ */ S("div", { className: "plan-purchase-sidebar__ticket-prices", children: [
          /* @__PURE__ */ s("h3", { className: "mb3 txtcenter", children: c("seating.plan_purchase.sidebar.title") }),
          _.filter((C) => (z(
            C.availableSeatList,
            "item.availableSeatList"
          ), !!C.availableSeatList.first())).map((C) => {
            var Gt, Ot, Dt;
            const {
              ticketPrice: k,
              stockContingent: y,
              participant: L,
              availableSeatList: I
            } = C, x = I == null ? void 0 : I.first();
            f(k, "ticketPrice"), f(x, "availableSeat");
            const { seat: v, seatGroup: T } = x;
            Y(T, "availableSeat.seatGroup"), f(v, "availableSeat.seat");
            const w = n(
              T,
              G(y)
            );
            F(
              y,
              "cartItem.stockContingent"
            );
            const R = (Gt = y == null ? void 0 : y.contingent) != null ? Gt : null;
            F(
              R,
              "cartItem.stockContingent?.contingent"
            ), F(L, "cartItem.participant");
            const X = Ve(L), ee = g.get(T), ra = (Ot = m.get(T)) != null ? Ot : void 0, yt = R == null ? void 0 : R.name, ca = (Dt = R == null ? void 0 : R.color) != null ? Dt : void 0, Pt = w.filter((J) => (f(J.bookingTrack, "tp.bookingTrack"), J.willGenerateTicket === !0)).map((J) => {
              var Fe, $e;
              return {
                label: (Fe = J.name) != null ? Fe : "",
                value: J.get("@id"),
                subLabel: ($e = ji(J, r)) != null ? $e : ""
              };
            }), wt = ei(c, v);
            return /* @__PURE__ */ S("div", { className: "mb3", children: [
              /* @__PURE__ */ S("div", { className: "mb1 plan-purchase-sidebar__seat-infos small mpd-color-gray", children: [
                X && /* @__PURE__ */ s("span", { className: "ellipsis", children: X }),
                wt.length > 0 && /* @__PURE__ */ s("span", { children: wt }),
                d === ae.Contingent && l === ge.DESK && !!yt && /* @__PURE__ */ S("span", { className: "ellipsis", children: [
                  /* @__PURE__ */ s(
                    Se,
                    {
                      icon: "seat-filled",
                      width: "14",
                      color: ca,
                      className: "mr1"
                    }
                  ),
                  yt
                ] }),
                (d === ae.SeatGroup || l === ge.MINISITE) && !!ee && /* @__PURE__ */ S("span", { className: "ellipsis", children: [
                  /* @__PURE__ */ s(
                    Se,
                    {
                      icon: "seat-filled",
                      width: "14",
                      color: ra,
                      className: "mr1"
                    }
                  ),
                  ee
                ] })
              ] }),
              /* @__PURE__ */ s(
                Ji,
                {
                  options: Pt.toArray(),
                  value: Pt.find(
                    (J) => J.value === k.get("@id")
                  ),
                  onChange: (J) => {
                    const Fe = w.find(
                      ($e) => $e.get("@id") === (J == null ? void 0 : J.value)
                    );
                    b(Fe, C);
                  },
                  searchable: !0,
                  clearable: !1
                }
              )
            ] }, C["@id"]);
          })
        ] })
      }
    )
  ] });
}
function je(e, n) {
  return e ? (z(e.cartItemList, "cart.cartItemList"), e.cartItemList.filter(
    (a) => na(a, n)
  ).map((a) => {
    z(
      a.availableSeatList,
      "cartItem.availableSeatList"
    );
    const i = a.availableSeatList.first();
    if (i)
      return f(
        i.seat,
        "cartItem.availableSeatList.seat"
      ), i;
  }).filter(
    (a) => typeof a != "undefined"
  )) : A();
}
function Kt(e, n) {
  return je(e, n).map(
    (t) => (f(
      t.seat,
      "cartItem.availableSeatList.seat"
    ), t.seat)
  );
}
function $o(e, n) {
  var a, i;
  z(
    n.cartItemWithOfferList,
    "cart.cartItemWithOfferList"
  );
  const t = (i = (a = n.cartItemWithOfferList.find((o) => {
    z(
      o.availableSeatList,
      "cartItemWithOffer.availableSeatList"
    );
    const r = o.availableSeatList.first();
    return !!r && G(r) === e["@id"];
  })) == null ? void 0 : a.availableSeatList) == null ? void 0 : i.first();
  return t ? (f(t, "foundAvailableSeat"), t) : null;
}
let zo = class extends Be {
  constructor(n) {
    super(n), this.state = {
      removedAvailableSeatCartList: A()
    }, this.init = this.init.bind(this), this.onClickSeat = this.onClickSeat.bind(this), this.getSelectableSeatIdSet = this.getSelectableSeatIdSet.bind(this), this.getTicketPriceListBySeatGroupAndStockContingent = this.getTicketPriceListBySeatGroupAndStockContingent.bind(this), this.getTicketPriceQuantityList = this.getTicketPriceQuantityList.bind(this), this.handleChangeTicketPrice = this.handleChangeTicketPrice.bind(this), this.getActiveSeatGroupListForMinisite = this.getActiveSeatGroupListForMinisite.bind(this), this.initCart = this.initCart.bind(this);
  }
  componentDidMount() {
    const { eventDateId: n } = this.props;
    if (!n)
      throw new Error("No eventDateId provided");
    this.init();
  }
  componentDidUpdate(n) {
    var u;
    const {
      selectedSeatIdSet: t,
      dispatchSetTicketPriceQuantity: a,
      selectedAvailableSeatList: i,
      cart: o,
      eventDateId: r,
      dispatchLockSeatsForEventDate: c,
      currentDomain: d
    } = this.props, l = Kt(
      o,
      r
    );
    if (!((u = n.selectedSeatIdSet) != null && u.equals(t))) {
      const p = l.map((b) => Number(b.getShortId())).toSet().sort();
      if (t === null || t.sort().equals(p))
        return;
      c(ct, r);
      const g = n.selectedAvailableSeatList.filter(
        (b) => !i.some(
          (C) => C["@id"] === b["@id"]
        )
      );
      g.size > 0 && (je(o, r), this.setState((b) => ({ removedAvailableSeatCartList: b.removedAvailableSeatCartList.concat(g).toSet().toList() })));
      const m = i.filter(
        (b) => !n.selectedAvailableSeatList.some(
          (C) => b["@id"] === C["@id"]
        )
      ), _ = this.getTicketPriceQuantityList(
        g,
        -1,
        o
      ), h = this.getTicketPriceQuantityList(
        m,
        1,
        o
      );
      a(
        ct,
        _.concat(h)
      );
    }
    n.currentDomain !== d && this.init();
  }
  componentWillUnmount() {
    const { resetState: n } = this.props;
    n();
  }
  // eslint-disable-next-line react/sort-comp
  init() {
    return K(this, null, function* () {
      const {
        eventDateId: n,
        initSeatingPlanPurchase: t,
        currentDomain: a,
        currentSellingDeviceId: i
      } = this.props;
      yield t(
        n,
        a,
        i
      ), this.initCart();
    });
  }
  initCart() {
    const {
      initBatchOfSeatsFromSeatList: n,
      cart: t,
      eventDateId: a,
      setAvailableSeatListAvailable: i
    } = this.props, o = Kt(
      t,
      a
    );
    t !== null && o.size > 0 && (n(o), i(
      je(t, a)
    ));
  }
  // eslint-disable-next-line react/sort-comp
  getTicketPriceQuantityList(n, t, a) {
    return n.map(
      (i) => {
        var l;
        f(
          i.seatGroup,
          "availableSeat.seatGroup"
        );
        const o = (l = i.stockContingent) != null ? l : null;
        F(o, "stockContingent");
        const c = this.getTicketPriceListBySeatGroupAndStockContingent(
          i.seatGroup["@id"],
          G(o)
        ).find((u) => u.bookableStock === null || u.bookableStock > 0);
        if (t > 0)
          return typeof c == "undefined" ? null : (o && f(o, "stockContingent"), {
            ticketPrice: c,
            quantityDelta: t,
            availableSeat: i["@id"],
            stockContingent: o ? new Xe(o) : null
          });
        if (!a)
          return null;
        const d = $o(
          i,
          a
        );
        return M(d, "availableSeatEntity"), rs(
          d,
          a,
          t,
          !0
        );
      }
    ).filter((i) => !!i);
  }
  // optimization needed in order to not re-enter the function everytime (memoization ?)
  getTicketPriceListBySeatGroupAndStockContingent(n, t) {
    const { currentDomain: a, ticketPriceList: i, currentContingentId: o } = this.props, r = i.filter(
      (c) => (z(
        c.ticketPriceSeatGroupList,
        "ticketPrice.ticketPriceSeatGroupList"
      ), f(
        c.bookingTrack,
        "ticketPrice.bookingTrack"
      ), F(
        c.defaultStockContingent,
        "ticketPrice.defaultStockContingent"
      ), a === ge.MINISITE && c.bookingTrack.cartType === St.OPTION || a === ge.MINISITE && t !== G(c.defaultStockContingent) ? !1 : c.ticketPriceSeatGroupList.some(
        (d) => d.seatGroup === n
      ))
    );
    if (!o) {
      const [c, d] = r.partition((l) => {
        var u;
        return F(l.defaultStockContingent), ((u = l.defaultStockContingent) == null ? void 0 : u["@id"]) === t;
      });
      return d.concat(c);
    }
    return r;
  }
  getActiveSeatGroupListForMinisite() {
    const { availableSeatList: n, currentContingentId: t } = this.props;
    return n.filter((a) => {
      var r;
      f(
        a.seatGroup,
        "availableSeat.seatGroup"
      );
      const i = (r = a.stockContingent) != null ? r : null;
      F(i, "stockContingent");
      const o = this.getTicketPriceListBySeatGroupAndStockContingent(
        a.seatGroup["@id"],
        G(i)
      );
      return Tt(
        a,
        o,
        t,
        a.status === Ge
      );
    }).map((a) => (f(
      a.seatGroup,
      "availableSeat.seatGroup"
    ), a.seatGroup)).toSet().toList().sortBy((a) => a.label);
  }
  handleChangeTicketPrice(n, t, a) {
    const { dispatchChangeAvailableSeatTicketPrice: i, eventDateId: o } = this.props;
    i(
      ct,
      o,
      n,
      t,
      a
    );
  }
  onClickSeat(n, t, a) {
    const { removeSeatFromSelectedSeats: i, addSeatToSelectedSeats: o } = this.props, r = Ae(n);
    a && (t ? i(r) : o(r));
  }
  getSelectableSeatIdSet(n, t) {
    const { getSelectableSeatIdSet: a, cart: i, eventDateId: o } = this.props, { removedAvailableSeatCartList: r } = this.state;
    return a(
      n,
      t,
      je(i, o),
      r
    );
  }
  render() {
    const {
      cart: n,
      isReady: t,
      seatConfig: a,
      sidebarPrevAction: i,
      sidebarNextAction: o,
      currentContingentId: r,
      eventDateId: c,
      currentDomain: d,
      isDrawingContext: l,
      locale: u,
      t: p,
      externalActions: g
    } = this.props;
    return t ? /* @__PURE__ */ s(Vo, { value: r, children: /* @__PURE__ */ s(
      "div",
      {
        className: "mpd-seating__app mpd-seating__app--plan-purchase",
        id: "mpd-seating__app",
        children: /* @__PURE__ */ S(
          "div",
          {
            className: "mpd-seating__app__container",
            ref: l.setSvgDrawerRef,
            children: [
              /* @__PURE__ */ S("div", { className: "mpd-seating__app__event-svg-wrapper", children: [
                d === ge.MINISITE && /* @__PURE__ */ S("div", { className: "seatgroup-sidebar", children: [
                  /* @__PURE__ */ s(
                    kn,
                    {
                      seatGroupList: this.getActiveSeatGroupListForMinisite(),
                      className: "seatgroup-sidebar__item"
                    }
                  ),
                  /* @__PURE__ */ S("div", { className: "legend-item seatgroup-sidebar__item", children: [
                    /* @__PURE__ */ s(
                      Se,
                      {
                        icon: "seat-filled",
                        width: "12",
                        color: Tn(Re, 0.3)
                      }
                    ),
                    /* @__PURE__ */ s("span", { className: "bold small ml2", children: p("seat.unavailable") })
                  ] })
                ] }),
                /* @__PURE__ */ s(
                  ce,
                  {
                    SeatElement: ia,
                    seatEntityType: "AvailableSeat",
                    getTicketPriceListBySeatGroup: this.getTicketPriceListBySeatGroupAndStockContingent,
                    getSelectableSeatIdSet: this.getSelectableSeatIdSet,
                    onClickSeat: this.onClickSeat,
                    seatConfigBlockList: (a == null ? void 0 : a.seatConfigBlockList) || [],
                    isMovingSeat: !1,
                    actionButtons: d === ge.DESK && /* @__PURE__ */ s(Ct, {}),
                    isPdfDownloadAvailable: d === ge.DESK,
                    externalActions: g
                  }
                )
              ] }),
              /* @__PURE__ */ s(
                Fo,
                {
                  cart: n,
                  locale: u,
                  eventDateId: c,
                  getTicketPriceListBySeatGroupAndStockContingent: this.getTicketPriceListBySeatGroupAndStockContingent,
                  handleChangeTicketPrice: this.handleChangeTicketPrice,
                  sidebarPrevAction: i,
                  sidebarNextAction: o
                }
              )
            ]
          }
        )
      }
    ) }) : /* @__PURE__ */ s(ue, {});
  }
};
function Wo(e) {
  const { t: n } = E(), t = xo(), { currentDomain: a } = Ue(), i = he(), o = ns(), r = te(), c = as(), d = is(), { eventDateId: l, currentContingentId: u, currentSellingDeviceId: p } = e, [g, m] = $(A()), _ = ss(), h = q.getSdk(), b = O(() => K(null, null, function* () {
    try {
      const C = An().second(0).format(), y = (yield h.getRepository("ticketPrice").findBy(
        D(N(N(N({
          sellingDevice: p,
          eventDate: l,
          visible: !0,
          willGenerateTicket: !0,
          hasBehaviour: !1
        }, a === ge.MINISITE && {
          "saleEndDate[after]": C,
          "saleStartDate[before]": C
        }), u && {
          contextualBookableStock: !0,
          stockContingent: u
        }), u && u !== os && {
          "order[stockContingent]": u
        }), {
          "order[manualSort]": "ASC"
        }),
        [
          "@id",
          "name",
          "facialValue",
          "currency",
          "buyable",
          "enabled",
          "bookableStock",
          "willGenerateTicket",
          "onSale",
          {
            defaultStockContingent: [
              "@id",
              "name",
              { contingent: ["name", "color"] }
            ]
          },
          {
            ticketPriceSeatGroupList: ["seatGroup"]
          },
          { bookingTrack: ["@id", "cartType"] }
        ]
      )).getMembers();
      m(y);
    } catch (C) {
      const k = yield xe(C);
      r({
        title: k,
        type: ve.ERROR
      });
    }
  }), [
    u,
    p,
    l,
    h,
    a,
    r
  ]);
  return B(() => {
    b();
  }, [b]), t ? /* @__PURE__ */ s(
    zo,
    D(N({}, e), {
      dispatchChangeAvailableSeatTicketPrice: _,
      dispatchLockSeatsForEventDate: c,
      dispatchSetTicketPriceQuantity: d,
      cart: o,
      currentDomain: a,
      ticketPriceList: g,
      isDrawingContext: i,
      t: n
    })
  ) : null;
}
const Ko = (e) => ({
  seatConfig: e.seating.get("seatConfig"),
  availableSeatList: e.seating.get("availableSeatList") || A(),
  isReady: fe(e),
  getSelectableSeatIdSet: si,
  selectedSeatIdSet: e.seating.get("selectedSeatIdSet"),
  selectedAvailableSeatList: ii(e) || A()
}), jo = {
  resetState: me,
  initSeatingPlanPurchase: ai,
  addSeatToSelectedSeats: Qe,
  removeSeatFromSelectedSeats: ft,
  initBatchOfSeatsFromSeatList: ni,
  setAvailableSeatListAvailable: ti
}, qo = se(
  Ko,
  jo
)(Wo), sa = de(
  (r) => {
    var c = r, {
      color: e,
      isSelectable: n,
      isSelected: t,
      bookingStatus: a,
      seatEntity: i
    } = c, o = j(c, [
      "color",
      "isSelectable",
      "isSelected",
      "bookingStatus",
      "seatEntity"
    ]);
    return /* @__PURE__ */ s(
      re,
      D(N({}, o), {
        seatEntity: i,
        isSelectable: n,
        bookingStatus: a,
        icon: "seat-filled",
        fill: e,
        isSelected: t,
        displaySeatLabel: !0
      })
    );
  }
);
sa.displayName = "SeatingPlanSpectatorSeat";
function Qo(e) {
  return z(e.cartItemList, "cart.cartItemList"), e.cartItemList.filter((n) => (z(
    n.availableSeatList,
    "cartItem.availableSeatList"
  ), !!n.availableSeatList.first())).groupBy((n) => (f(n.ticketPrice, "cartItem.ticketPrice"), n.ticketPrice.get("@id"))).map((n) => {
    var i;
    const t = n.first();
    M(t, "firstItem"), f(t.ticketPrice, "firstItem.ticketPrice"), Y(
      t.ticketPrice.name,
      "firstItem.ticketPrice.name"
    );
    const a = (i = t.availableSeatList) == null ? void 0 : i.first();
    return f(a, "firstAvailableSeat"), f(
      a.seatGroup,
      "firstAvailableSeat.seatGroup"
    ), Y(
      a.seatGroup.seatColor,
      "firstAvailableSeat.seatGroup.seatColor"
    ), {
      ticketPriceName: t.ticketPrice.name,
      seatLabelsList: n.map((o) => {
        z(
          o.availableSeatList,
          "cartItem.availableSeatList"
        );
        const r = o.availableSeatList.first();
        return f(r, "availableSeat"), f(r.seat, "availableSeat.seat"), Y(
          r.seat.label,
          "availableSeat.seat.label"
        ), r.seat.label;
      }),
      price: oe(
        t.ticketPrice.facialValue,
        t.ticketPrice.currency
      ),
      count: n.size,
      seatGroupColor: a.seatGroup.seatColor
    };
  }).toList();
}
function Ho(e) {
  return z(e.ticketList, "order.ticketList"), e.ticketList.filter((n) => n.availableSeat).groupBy((n) => n.ticketPriceName).map((n) => {
    const t = n.first();
    return M(t, "firstTicket"), M(
      t.ticketPriceName,
      "firstTicket.ticketPriceName"
    ), f(
      t.availableSeat,
      "firstTicket.availableSeat"
    ), f(
      t.availableSeat.seatGroup,
      "firstTicket.availableSeat.seatGroup"
    ), Y(
      t.availableSeat.seatGroup.seatColor,
      "firstTicket.availableSeat.seatGroup.seatColor"
    ), {
      ticketPriceName: t.ticketPriceName,
      seatLabelsList: n.map((a) => (f(a.availableSeat, "ticket.availableSeat"), f(
        a.availableSeat.seat,
        "ticket.availableSeat.seat"
      ), Y(
        a.availableSeat.seat.label,
        "ticket.availableSeat.seat.label"
      ), a.availableSeat.seat.label)),
      price: oe(t.facialValue, t.currency),
      count: n.size,
      seatGroupColor: t.availableSeat.seatGroup.seatColor
    };
  }).toList();
}
function Xo({ booking: e }) {
  const { t: n } = E();
  if (!e)
    return /* @__PURE__ */ s(pe, { className: "spectator-sidebar" });
  const t = sn(e) ? Ho(e) : Qo(e);
  if (t.size === 0)
    return null;
  F(e.customer, "booking.customer");
  const a = Ve(e.customer), i = oe(e.retailValue, e.currency);
  return /* @__PURE__ */ s(
    pe,
    {
      className: "spectator-sidebar",
      action: !!i && /* @__PURE__ */ S("div", { className: "spectator-sidebar__total larger p3", children: [
        n("spectator_screen.total"),
        /* @__PURE__ */ s("span", { className: "bold", children: i })
      ] }),
      children: /* @__PURE__ */ S("div", { className: "p3 large", children: [
        a && /* @__PURE__ */ s("h2", { className: "spectator-sidebar__border mb2 pb2", children: a }),
        t.map((o) => /* @__PURE__ */ S(
          "div",
          {
            className: "spectator-sidebar__border mb2 pb2",
            children: [
              /* @__PURE__ */ S("div", { children: [
                /* @__PURE__ */ s(
                  Se,
                  {
                    icon: "seat-filled",
                    className: "mr1",
                    color: o.seatGroupColor
                  }
                ),
                /* @__PURE__ */ s("span", { className: "bold", children: o.seatLabelsList.join(", ") })
              ] }),
              /* @__PURE__ */ S("span", { className: "block", children: [
                o.count,
                "x ",
                o.ticketPriceName
              ] }),
              /* @__PURE__ */ s("span", { className: "block bold larger", children: o.price })
            ]
          },
          o.ticketPriceName
        ))
      ] })
    }
  );
}
function Yo({
  eventDateId: e,
  cartId: n,
  orderId: t,
  currentSellingDeviceId: a,
  isReady: i,
  seatConfig: o,
  availableSeatList: r,
  initSeatingPlanSpectator: c,
  initCartReplacement: d,
  initOrderReplacement: l,
  resetState: u
}) {
  const { t: p } = E(), g = te(), m = U(), [_, h] = $(A()), [b, C] = $(null), k = q.getSdk();
  B(() => {
    n ? d(n, e) : t ? l(t, e) : c(e);
  }, [
    e,
    n,
    t,
    c,
    d,
    l
  ]), B(() => {
    if (!i)
      return;
    const v = `/v1/event_dates/${e}`;
    n ? K(null, null, function* () {
      M(n, "cartId");
      const R = yield k.getRepository("cart").find(n, { fields: _t }), X = vt(R, v), ee = Ee(X);
      m(He(ee)), C(X);
    }) : t && K(null, null, function* () {
      M(t, "orderId");
      const R = yield k.getRepository("order").find(t, { fields: Nt }), X = It(R, v), ee = Je(X);
      m(He(ee)), C(X);
    });
  }, [
    i,
    n,
    t,
    e,
    k,
    m,
    r
  ]), B(() => () => {
    u();
  }, [u]);
  const y = O(
    (v, T) => b ? Lt(v, T, b) : oi(v, T),
    [b]
  ), L = O(() => K(null, null, function* () {
    try {
      const v = An().second(0).format(), w = (yield k.getRepository("ticketPrice").findBy(
        {
          sellingDevice: a,
          eventDate: e,
          visible: !0,
          willGenerateTicket: !0,
          hasBehaviour: !1,
          "saleEndDate[after]": v,
          "saleStartDate[before]": v,
          "order[manualSort]": "ASC"
        },
        [
          "@id",
          "name",
          "facialValue",
          "currency",
          "buyable",
          "enabled",
          "bookableStock",
          "willGenerateTicket",
          "onSale",
          {
            ticketPriceSeatGroupList: ["seatGroup"]
          }
        ]
      )).getMembers();
      h(w);
    } catch (v) {
      const T = yield xe(v);
      g({
        title: T,
        type: ve.ERROR
      });
    }
  }), [a, e, k, g]);
  B(() => {
    L();
  }, [L]);
  const I = O(
    (v) => _.filter(
      (w) => (z(
        w.ticketPriceSeatGroupList,
        "ticketPrice.ticketPriceSeatGroupList"
      ), w.ticketPriceSeatGroupList.some(
        (R) => R.seatGroup === v
      ))
    ),
    [_]
  ), x = O(() => r.filter((v) => {
    var R;
    f(
      v.seatGroup,
      "availableSeat.seatGroup"
    );
    const T = (R = v.stockContingent) != null ? R : null;
    F(T, "stockContingent");
    const w = I(
      v.seatGroup["@id"]
    );
    return Tt(
      v,
      w,
      null,
      v.status === Ge
    );
  }).map((v) => (f(
    v.seatGroup,
    "availableSeat.seatGroup"
  ), v.seatGroup)).toSet().toList(), [r, I]);
  return i ? /* @__PURE__ */ s(
    "div",
    {
      className: "mpd-seating__app mpd-seating__app--plan-spectator",
      id: "mpd-seating__app",
      children: /* @__PURE__ */ S("div", { className: "mpd-seating__app__container", children: [
        /* @__PURE__ */ S("div", { className: "mpd-seating__app__event-svg-wrapper", children: [
          /* @__PURE__ */ S("div", { className: "seatgroup-sidebar seatgroup-sidebar--bottom", children: [
            /* @__PURE__ */ s(
              kn,
              {
                seatGroupList: x(),
                className: "seatgroup-sidebar__item"
              }
            ),
            /* @__PURE__ */ S("div", { className: "legend-item seatgroup-sidebar__item", children: [
              /* @__PURE__ */ s(
                Se,
                {
                  icon: "seat-filled",
                  width: "12",
                  color: Tn(Re, 0.3)
                }
              ),
              /* @__PURE__ */ s("span", { className: "bold small ml2", children: p("seat.unavailable") })
            ] })
          ] }),
          /* @__PURE__ */ s(
            ce,
            {
              SeatElement: sa,
              seatEntityType: "AvailableSeat",
              getTicketPriceListBySeatGroup: I,
              getSelectableSeatIdSet: y,
              seatConfigBlockList: (o == null ? void 0 : o.seatConfigBlockList) || [],
              isMovingSeat: !1,
              isSpectatorScreen: !0
            }
          )
        ] }),
        /* @__PURE__ */ s(Xo, { booking: b })
      ] })
    }
  ) : /* @__PURE__ */ s(ue, {});
}
const Zo = (e) => ({
  seatConfig: e.seating.get("seatConfig"),
  availableSeatList: e.seating.get("availableSeatList") || A(),
  isReady: fe(e)
}), Jo = {
  resetState: me,
  initSeatingPlanSpectator: ri,
  initCartReplacement: dn,
  initOrderReplacement: vn
}, er = se(
  Zo,
  Jo
)(Yo), oa = de((t) => {
  var a = t, { color: e } = a, n = j(a, ["color"]);
  return /* @__PURE__ */ s(
    re,
    D(N({}, n), {
      icon: "seat-filled",
      fill: e,
      displaySeatLabel: !0,
      isSelectable: !0
    })
  );
});
oa.displayName = "SeatingPlanViewerSeat";
const tr = () => {
};
let nr = class extends Be {
  constructor(n) {
    super(n), this.init = this.init.bind(this);
  }
  componentDidMount() {
    this.init();
  }
  componentWillUnmount() {
    const { resetState: n } = this.props;
    n();
  }
  init() {
    const { seatConfigId: n, initSeatingPlanViewer: t } = this.props;
    if (!n)
      throw new Error("No seatConfigId provided");
    t(n);
  }
  render() {
    const { isReady: n, getSelectableSeatIdSet: t, seatConfig: a } = this.props;
    return n ? /* @__PURE__ */ s("div", { className: "mpd-seating__app", id: "mpd-seating__app", children: /* @__PURE__ */ s("div", { className: "mpd-seating__app__container", children: /* @__PURE__ */ s("div", { className: "mpd-seating__app__event-svg-wrapper", children: /* @__PURE__ */ s(
      ce,
      {
        SeatElement: oa,
        seatEntityType: "Seat",
        getSelectableSeatIdSet: t,
        onClickSeat: tr,
        seatConfigBlockList: a ? a.seatConfigBlockList : [],
        isMovingSeat: !1,
        isPdfDownloadAvailable: !0
      }
    ) }) }) }) : /* @__PURE__ */ s(ue, {});
  }
};
const ar = () => V(), ir = (e) => ({
  seatConfig: e.seating.get("seatConfig"),
  isReady: _n(e),
  getSelectableSeatIdSet: ar
}), sr = {
  resetState: me,
  initSeatingPlanViewer: ci
}, or = se(
  ir,
  sr
)(nr), jt = [
  "#895274",
  "#22A7B8",
  "#CD5C52",
  "#F5A623",
  // The following colors where not selected by our designer, but chosen randomly
  "#DB0A5B",
  "#005555",
  "#3455DB",
  "#002A15"
], qt = W({
  contract: null,
  seatGroupList: null,
  eventDate: null,
  // The focused state is used in EventDateAdmin context only
  // to know which booking / seats is currently focused
  focusedBooking: null,
  // If we're on a context with an eventDate, we shall use availableSeatList, otherwise, we shall use seatList
  availableSeatList: null,
  stockContingentList: null,
  logicalSeatConfig: null,
  availableSeatModelList: null,
  contingentList: null,
  seatList: null,
  seatConfig: null,
  "movingSeat-fetch-status": W({
    status: ""
  }),
  "seat-status": W({
    status: ""
  }),
  "updatingAvailableSeatModelList-fetch-status": W({
    status: ""
  }),
  /**
  * - Used in Editor context to make batch actions on a seat of list
  - Used in CartReplacement, OrderReplacement and OrderViewer contexts to select seats to move
  */
  selectedSeatIdSet: null,
  renderingContext: null,
  pdfInfo: {}
});
function rr(e) {
  const n = jt.length, t = e >= n ? e % n : e;
  return jt[t];
}
function cr(e, n) {
  let t = W({});
  return n.map((a) => a.seatGroup).filter((a) => a !== null).forEach((a) => {
    t.has(a["@id"]) || (t = t.set(a["@id"], a));
  }), e.set(
    "seatGroupList",
    t.toList().sortBy((a) => a.label)
  ).set("focusedBooking", null).set("availableSeatList", A(n)).set(
    "seatList",
    A(
      n.map((a) => a.seat).filter((a) => a !== null)
    )
  );
}
function lr(e, n) {
  let t = W({});
  n.map((i) => i.seatGroup).filter((i) => i !== null).forEach((i) => {
    t.has(i["@id"]) || (t = t.set(i["@id"], i));
  });
  let a = W({});
  return n.map((i) => i.contingent).filter((i) => i !== null).forEach((i) => {
    a.has(G(i)) || (a = a.set(G(i), i));
  }), e.set("seatGroupList", t.toList()).set("focusedBooking", null).set("availableSeatModelList", A(n)).set(
    "seatList",
    A(
      n.map((i) => i.seat).filter((i) => i !== null)
    )
  ).set(
    "contingentList",
    a.toList().sort((i, o) => !i.name || !o.name ? 0 : i.name.localeCompare(o.name))
  );
}
function We(e, n, t = !1) {
  let a = e;
  return t && (a = ur(
    e,
    A(n.seatGroupList || [])
  ), a = dr(
    a,
    A(n.seatGroupList || [])
  )), a.set("seatConfig", n);
}
function dr(e, n) {
  const t = n.map((i) => hn(i.seatList)).toArray(), a = [].concat.apply(
    [],
    t
  );
  return e.set("seatList", A(a));
}
function ur(e, n) {
  let t = 0;
  return n.forEach((a) => {
    a.seatColor === null && (a.seatColor = rr(t), t += 1);
  }), e.set("seatGroupList", n);
}
function gr(e, n) {
  const t = (e.get("seatList") || A()).map(
    (i) => {
      const o = n.findIndex(
        (r) => r["@id"] === i["@id"]
      );
      if (o >= 0) {
        const r = n.get(o);
        if (!r)
          throw new Error("seat should be defined. This should not happen");
        return r;
      }
      return i;
    }
  );
  if (!e.get("seatConfig"))
    throw new Error("old seat config should exist. This should not happen.");
  return e.set("seatList", t);
}
function pr(e, n, t, a) {
  const o = (e.get("seatList") || A()).findIndex(
    (r) => r["@id"] === n
  );
  if (o >= 0) {
    const r = N({}, e.getIn(["seatList", o]));
    return r.coordinates.X = t, r.coordinates.Y = a, e.setIn(["seatList", o], r);
  }
  return e;
}
function Sr(e, n, t) {
  let a = e.get("availableSeatModelList") || A();
  return n.forEach((i) => {
    var r;
    const o = a.findIndex(
      (c) => c["@id"] === i["@id"]
    );
    if (o !== -1) {
      const c = a.get(o);
      if (c) {
        let d;
        if (t === "contingent") {
          const l = (r = e.get("contingentList")) == null ? void 0 : r.find((u) => u.get("@id") === i.contingent);
          l && (d = l);
        } else
          d = i[t];
        a = a.set(
          o,
          D(N({}, c), {
            [t]: d
          })
        );
      }
    }
  }), e.set("availableSeatModelList", a);
}
function mr(e, n, t) {
  var c;
  const a = e, i = `/v1/seats/${n}`, o = (e.get("availableSeatList") || A()).findIndex((d) => (M(d, "as"), f(d.seat, "as.seat"), d.seat["@id"] === i));
  let r = null;
  switch (t) {
    case ne.AVAILABLE:
    case ne.DISMISSED:
      r = t;
      break;
    case ne.SCANNED:
    case ne.IN_ORDER:
      r = Yi;
      break;
    case ne.IN_CART:
    case ne.IN_RESERVATION:
      r = Xi;
      break;
    default:
      throw new Error(
        `Unable to set status according to booking status ${t}`
      );
  }
  if (o >= 0) {
    const d = a.getIn([
      "availableSeatList",
      o
    ]);
    if (typeof d == "undefined")
      throw new Error(
        `Unable to find available seat with id ${i}. This should not happen.`
      );
    const l = D(N({}, d), {
      status: r,
      bookingStatus: t
    });
    return a.setIn(
      ["availableSeatList", o],
      l
    );
  }
  return (c = a.get("selectedSeatIdSet")) != null && c.has(n) ? a.set("selectedSeatIdSet", V()) : a;
}
function hr(e, n) {
  const t = n.reduce(
    (a, i) => {
      const o = a.findEntry(
        (l) => l["@id"] === i["@id"]
      );
      if (!o)
        return a;
      const [r, c] = o, d = D(N({}, c), {
        seatGroup: i.seatGroup
      });
      return a.set(r, d);
    },
    e.get("availableSeatList") || A()
  );
  return e.set("availableSeatList", t);
}
function Rr(e = qt, n) {
  var o, r;
  let t, a, i;
  switch (n.type) {
    case bn:
      return qt.set("contract", e.get("contract"));
    case Bi:
      return e.set("contract", n.contract);
    case Mi:
      return e.set("eventDate", n.eventDate);
    case Ri:
      return We(
        e,
        n.seatConfig,
        n.extractSeatGroupsAndSeats
      );
    case Di:
      return e.set("logicalSeatConfig", n.logicalSeatConfig).set("seatConfig", n.logicalSeatConfig.seatConfig);
    case Oi:
      return cr(e, n.availableSeatList);
    case Gi:
      return lr(e, n.availableSeatModelList);
    case wi:
      return mr(e, n.seatId, n.bookingStatus);
    case Pi: {
      const l = e.get("availableSeatList");
      if (!l)
        return e;
      const u = n.availableSeatList.map((m) => m["@id"]).toSet(), p = l.entrySeq().filter(
        ([m, _]) => u.has(_["@id"])
      ), g = l.withMutations(
        (m) => {
          p.forEach(([_]) => {
            m.setIn([_, "bookingStatus"], "available");
          });
        }
      );
      return e.set("availableSeatList", g);
    }
    case yi:
      return n.isSelected ? e.set("selectedSeatIdSet", V([n.seatId])) : e.set("selectedSeatIdSet", V());
    case Ei: {
      const l = n.seatList.map((u) => parseInt(u["@id"].replace("/v1/seats/", ""), 10)).toSet();
      return e.set("selectedSeatIdSet", l).set("focusedBooking", null);
    }
    case Ai:
      return e.set(
        "updatingAvailableSeatModelList-fetch-status",
        W({
          status: "IN_PROGRESS"
        })
      );
    case Ti:
      return e.set(
        "updatingAvailableSeatModelList-fetch-status",
        W({
          status: "ERROR"
        })
      );
    case Ii:
      return Sr(
        e,
        n.availableSeatModelList,
        n.updatedFieldName
      ).set(
        "updatingAvailableSeatModelList-fetch-status",
        W({
          status: "SUCCEEDED"
        })
      );
    case Ni:
      return e.set(
        "movingSeat-fetch-status",
        W({
          status: "IN_PROGRESS"
        })
      );
    case Li:
      return e.set(
        "movingSeat-fetch-status",
        W({
          status: "ERROR"
        })
      );
    case ki: {
      const { availableSeat: l } = n;
      let u = e.get("selectedSeatIdSet");
      const p = (r = (o = e.get("availableSeatList")) == null ? void 0 : o.map((g) => {
        var m;
        return f(g.seat), f(l.seat), g.seat["@id"] === l.seat["@id"] ? D(N({}, g), {
          bookingStatus: l.bookingStatus,
          ticket: l.ticket,
          cartItem: l.cartItem
        }) : l.ticket !== null && g.ticket === l.ticket || l.cartItem !== null && g.cartItem === l.cartItem ? (u = (m = u == null ? void 0 : u.remove(
          Number(Q(g.seat["@id"]))
        )) != null ? m : null, D(N({}, g), {
          bookingStatus: ne.AVAILABLE,
          ticket: null,
          cartItem: null
        })) : g;
      })) != null ? r : A();
      return e.set(
        "movingSeat-fetch-status",
        W({
          status: "SUCCEEDED"
        })
      ).set("availableSeatList", p).set("selectedSeatIdSet", u).set("focusedBooking", null);
    }
    case vi: {
      const l = e.get("seatConfig");
      if (!l)
        throw new Error(
          "old seat config should exist. This should not happen."
        );
      const u = N({}, l);
      return i = u.seatConfigBlockList.slice(0), i.push(n.seatConfigBlock), We(e, D(N({}, u), {
        seatConfigBlockList: i
      }));
    }
    case _i: {
      const l = e.get("seatConfig");
      if (!l)
        throw new Error(
          "old seat config should exist. This should not happen."
        );
      return a = N({}, l), i = a.seatConfigBlockList.slice(0), n.index >= 0 ? (i.splice(n.index, 1), We(e, D(N({}, a), { seatConfigBlockList: i }))) : e;
    }
    case Ci: {
      const l = e.get("seatConfig");
      if (!l)
        throw new Error(
          "old seat config should exist. This should not happen."
        );
      return a = N({}, l), i = a.seatConfigBlockList.slice(0), t = i.findIndex(
        (u) => u["@id"] === n.id
      ), t >= 0 ? (i[t].info = n.info, We(e, D(N({}, a), { seatConfigBlockList: i }))) : e;
    }
    case fi:
      return e.set("focusedBooking", n.booking);
    case bi:
      return e.set("focusedBooking", null).set("selectedSeatIdSet", V());
    case hi: {
      const { seatList: l } = n;
      return gr(e, l);
    }
    case mi: {
      const { seatId: l, x: u, y: p } = n;
      return pr(e, l, u, p);
    }
    case Si: {
      const { seatContingentMap: l } = n, u = (e.get("availableSeatModelList") || A()).map(
        (p) => {
          const g = l[p["@id"]] || null;
          return D(N({}, p), {
            contingent: g
          });
        }
      );
      return e.set("availableSeatModelList", u);
    }
    case Jt:
      return e.set("stockContingentList", n.stockContingentList);
    case pi: {
      const l = e.get("seatGroupList") || A();
      return e.set("seatGroupList", l.push(n.seatGroup));
    }
    case gi: {
      const l = e.get("contingentList") || A();
      return e.set(
        "contingentList",
        l.push(n.contingent)
      );
    }
    case ui: {
      const l = e.get("contingentList") || A(), u = l.findIndex(
        (p) => G(p) === n.contingentId
      );
      return u !== -1 ? e.set(
        "contingentList",
        l.delete(u)
      ) : e;
    }
    case di:
      return hr(e, n.availableSeatList);
    case Ht:
      const { stockContingent: c } = n;
      return e.set("pdfInfo", {
        stockContingent: c
      });
    case gt:
      return e.set("pdfInfo", {});
    case Qt:
      const { seatGroup: d } = n;
      return e.set("pdfInfo", {
        seatGroup: d
      });
    case ut:
      return e.set("pdfInfo", {});
    case li:
      return e.set("renderingContext", n.renderingContext);
    default:
      return e;
  }
}
function Mr(e) {
  return /* @__PURE__ */ s(le, { name: ie.SEATING_PLAN_PURCHASE, children: /* @__PURE__ */ s(qo, N({}, e)) });
}
function Br(e) {
  const i = e, { selectedView: n, onSelectView: t } = i, a = j(i, ["selectedView", "onSelectView"]);
  return /* @__PURE__ */ s(
    le,
    {
      name: ie.CART_REPLACEMENT,
      selectedView: n,
      onSelectView: t,
      children: /* @__PURE__ */ s(Bs, N({}, a))
    }
  );
}
function xr(e) {
  const i = e, { selectedView: n, onSelectView: t } = i, a = j(i, ["selectedView", "onSelectView"]);
  return /* @__PURE__ */ s(
    le,
    {
      name: ie.ORDER_REPLACEMENT,
      selectedView: n,
      onSelectView: t,
      children: /* @__PURE__ */ s(Po, N({}, a))
    }
  );
}
function Vr(e) {
  const o = e, { contract: n, selectedView: t, onSelectView: a } = o, i = j(o, ["contract", "selectedView", "onSelectView"]);
  return /* @__PURE__ */ s(
    xi,
    {
      name: ie.LOGICAL_SEAT_CONFIG_ADMIN,
      contract: n,
      selectedView: t,
      onSelectView: a,
      children: /* @__PURE__ */ s(no, N({}, i))
    }
  );
}
function Ur(e) {
  return /* @__PURE__ */ s(le, { name: ie.STOCK_MANAGEMENT, children: /* @__PURE__ */ s(Ts, N({}, e)) });
}
function Fr(e) {
  return /* @__PURE__ */ s(le, { name: ie.ORDER_VIEWER, viewList: [ae.SeatGroup], children: /* @__PURE__ */ s(Mo, N({}, e)) });
}
function $r(e) {
  return /* @__PURE__ */ s(le, { name: ie.SEATING_PLAN_VIEWER, children: /* @__PURE__ */ s(or, N({}, e)) });
}
function zr(e) {
  return /* @__PURE__ */ s(
    le,
    {
      name: ie.SEATING_PLAN_SPECTATOR,
      viewList: [ae.SeatGroup],
      children: /* @__PURE__ */ s(er, N({}, e))
    }
  );
}
function Wr(e) {
  return /* @__PURE__ */ s(le, { name: ie.ORDER_MANAGEMENT, children: /* @__PURE__ */ s(Co, N({}, e)) });
}
function Kr(e) {
  const o = e, { selectedView: n, onSelectView: t, selectedIndex: a } = o, i = j(o, ["selectedView", "onSelectView", "selectedIndex"]);
  return /* @__PURE__ */ s(
    le,
    {
      name: a || ie.MULTI_CONTEXT_PLAN,
      selectedView: n,
      onSelectView: t,
      children: /* @__PURE__ */ s(
        cs,
        N({
          selectedIndex: a
        }, i)
      )
    }
  );
}
export {
  Br as CartReplacement,
  Vr as LogicalSeatConfigAdmin,
  ki as MOVE_SEAT_LIST_SUCCESS,
  ie as MULTI_CONTEXT_PLAN_NAMES,
  Aa as MomentInstance,
  Kr as MultiContextPlan,
  Wr as OrderManagement,
  xr as OrderReplacement,
  Fr as OrderViewer,
  Mr as SeatingPlanPurchase,
  zr as SeatingPlanSpectator,
  $r as SeatingPlanViewer,
  Qr as SeatingTransformProvider,
  Ur as StockManagement,
  q as TicketingSdkInstance,
  ae as View,
  Hr as composeTransformMatrix,
  Xr as eventDateSelector,
  Yr as i18n,
  dn as initCartReplacement,
  vn as initOrderReplacement,
  Zr as parseTransformMatrix,
  Rr as seatingReducer
};
//# sourceMappingURL=index.js.map
